import { ThemePreset } from "../types/theme";

export const defaultPresets: Record<string, ThemePreset> = {
  "modern-minimal": {
    label: "Modern Minimal",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#333333",
        card: "#ffffff",
        "card-foreground": "#333333",
        popover: "#ffffff",
        "popover-foreground": "#333333",
        primary: "#3b82f6",
        "primary-foreground": "#ffffff",
        secondary: "#f3f4f6",
        "secondary-foreground": "#4b5563",
        muted: "#f9fafb",
        "muted-foreground": "#6b7280",
        accent: "#e0f2fe",
        "accent-foreground": "#1e3a8a",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#e5e7eb",
        input: "#e5e7eb",
        ring: "#3b82f6",
        "chart-1": "#3b82f6",
        "chart-2": "#2563eb",
        "chart-3": "#1d4ed8",
        "chart-4": "#1e40af",
        "chart-5": "#1e3a8a",
        radius: "0.375rem",
        sidebar: "#f9fafb",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#3b82f6",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#e0f2fe",
        "sidebar-accent-foreground": "#1e3a8a",
        "sidebar-border": "#e5e7eb",
        "sidebar-ring": "#3b82f6",
        "font-sans": "Inter, sans-serif",
        "font-serif": "Source Serif 4, serif",
        "font-mono": "JetBrains Mono, monospace",
      },
      dark: {
        background: "#171717",
        foreground: "#e5e5e5",
        card: "#262626",
        "card-foreground": "#e5e5e5",
        popover: "#262626",
        "popover-foreground": "#e5e5e5",
        primary: "#3b82f6",
        "primary-foreground": "#ffffff",
        secondary: "#262626",
        "secondary-foreground": "#e5e5e5",
        muted: "#262626",
        "muted-foreground": "#a3a3a3",
        accent: "#1e3a8a",
        "accent-foreground": "#bfdbfe",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#404040",
        input: "#404040",
        ring: "#3b82f6",
        "chart-1": "#60a5fa",
        "chart-2": "#3b82f6",
        "chart-3": "#2563eb",
        "chart-4": "#1d4ed8",
        "chart-5": "#1e40af",
        radius: "0.375rem",
        sidebar: "#171717",
        "sidebar-foreground": "#e5e5e5",
        "sidebar-primary": "#3b82f6",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#1e3a8a",
        "sidebar-accent-foreground": "#bfdbfe",
        "sidebar-border": "#404040",
        "sidebar-ring": "#3b82f6",
      },
    },
  },

  "violet-bloom": {
    label: "Violet Bloom",
    createdAt: "2025-06-26",
    styles: {
      light: {
        background: "#fdfdfd",
        foreground: "#000000",
        card: "#fdfdfd",
        "card-foreground": "#000000",
        popover: "#fcfcfc",
        "popover-foreground": "#000000",
        primary: "#7033ff",
        "primary-foreground": "#ffffff",
        secondary: "#edf0f4",
        "secondary-foreground": "#080808",
        muted: "#f5f5f5",
        "muted-foreground": "#525252",
        accent: "#e2ebff",
        "accent-foreground": "#1e69dc",
        destructive: "#e54b4f",
        "destructive-foreground": "#ffffff",
        border: "#e7e7ee",
        input: "#ebebeb",
        ring: "#000000",
        "chart-1": "#4ac885",
        "chart-2": "#7033ff",
        "chart-3": "#fd822b",
        "chart-4": "#3276e4",
        "chart-5": "#747474",
        sidebar: "#f5f8fb",
        "sidebar-foreground": "#000000",
        "sidebar-primary": "#000000",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#ebebeb",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#ebebeb",
        "sidebar-ring": "#000000",
        "font-sans": "Plus Jakarta Sans, sans-serif",
        "font-serif": "Lora, serif",
        "font-mono": "IBM Plex Mono, monospace",
        radius: "1.4rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.16",
        "shadow-blur": "3px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
        "letter-spacing": "-0.025em",
        spacing: "0.27rem",
      },
      dark: {
        background: "#1a1b1e",
        foreground: "#f0f0f0",
        card: "#222327",
        "card-foreground": "#f0f0f0",
        popover: "#222327",
        "popover-foreground": "#f0f0f0",
        primary: "#8c5cff",
        "primary-foreground": "#ffffff",
        secondary: "#2a2c33",
        "secondary-foreground": "#f0f0f0",
        muted: "#2a2c33",
        "muted-foreground": "#a0a0a0",
        accent: "#1e293b",
        "accent-foreground": "#79c0ff",
        destructive: "#f87171",
        "destructive-foreground": "#ffffff",
        border: "#33353a",
        input: "#33353a",
        ring: "#8c5cff",
        "chart-1": "#4ade80",
        "chart-2": "#8c5cff",
        "chart-3": "#fca5a5",
        "chart-4": "#5993f4",
        "chart-5": "#a0a0a0",
        sidebar: "#161618",
        "sidebar-foreground": "#f0f0f0",
        "sidebar-primary": "#8c5cff",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#2a2c33",
        "sidebar-accent-foreground": "#8c5cff",
        "sidebar-border": "#33353a",
        "sidebar-ring": "#8c5cff",
        "font-sans": "Plus Jakarta Sans, sans-serif",
        "font-serif": "Lora, serif",
        "font-mono": "IBM Plex Mono, monospace",
        radius: "1.4rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.16",
        "shadow-blur": "3px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
        "letter-spacing": "-0.025em",
        spacing: "0.27rem",
      },
    },
  },

  "t3-chat": {
    label: "T3 Chat",
    createdAt: "2025-04-19",
    styles: {
      light: {
        background: "#faf5fa",
        foreground: "#501854",
        card: "#faf5fa",
        "card-foreground": "#501854",
        popover: "#ffffff",
        "popover-foreground": "#501854",
        primary: "#a84370",
        "primary-foreground": "#ffffff",
        secondary: "#f1c4e6",
        "secondary-foreground": "#77347c",
        muted: "#f6e5f3",
        "muted-foreground": "#834588",
        accent: "#f1c4e6",
        "accent-foreground": "#77347c",
        destructive: "#ab4347",
        "destructive-foreground": "#ffffff",
        border: "#efbdeb",
        input: "#e7c1dc",
        ring: "#db2777",
        "chart-1": "#d926a2",
        "chart-2": "#6c12b9",
        "chart-3": "#274754",
        "chart-4": "#e8c468",
        "chart-5": "#f4a462",
        sidebar: "#f3e4f6",
        "sidebar-foreground": "#ac1668",
        "sidebar-primary": "#454554",
        "sidebar-primary-foreground": "#faf1f7",
        "sidebar-accent": "#f8f8f7",
        "sidebar-accent-foreground": "#454554",
        "sidebar-border": "#eceae9",
        "sidebar-ring": "#db2777",
        radius: "0.5rem",
      },
      dark: {
        background: "#221d27",
        foreground: "#d2c4de",
        card: "#2c2632",
        "card-foreground": "#dbc5d2",
        popover: "#100a0e",
        "popover-foreground": "#f8f1f5",
        primary: "#a3004c",
        "primary-foreground": "#efc0d8",
        secondary: "#362d3d",
        "secondary-foreground": "#d4c7e1",
        muted: "#28222d",
        "muted-foreground": "#c2b6cf",
        accent: "#463753",
        "accent-foreground": "#f8f1f5",
        destructive: "#301015",
        "destructive-foreground": "#ffffff",
        border: "#3b3237",
        input: "#3e343c",
        ring: "#db2777",
        "chart-1": "#a84370",
        "chart-2": "#934dcb",
        "chart-3": "#e88c30",
        "chart-4": "#af57db",
        "chart-5": "#e23670",
        sidebar: "#181117",
        "sidebar-foreground": "#e0cad6",
        "sidebar-primary": "#1d4ed8",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#261922",
        "sidebar-accent-foreground": "#f4f4f5",
        "sidebar-border": "#000000",
        "sidebar-ring": "#db2777",
      },
    },
  },

  twitter: {
    label: "Twitter",
    createdAt: "2025-04-24",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#0f1419",
        card: "#f7f8f8",
        "card-foreground": "#0f1419",
        popover: "#ffffff",
        "popover-foreground": "#0f1419",
        primary: "#1e9df1",
        "primary-foreground": "#ffffff",
        secondary: "#0f1419",
        "secondary-foreground": "#ffffff",
        muted: "#E5E5E6",
        "muted-foreground": "#0f1419",
        accent: "#E3ECF6",
        "accent-foreground": "#1e9df1",
        destructive: "#f4212e",
        "destructive-foreground": "#ffffff",
        border: "#e1eaef",
        input: "#f7f9fa",
        ring: "#1da1f2",
        "chart-1": "#1e9df1",
        "chart-2": "#00b87a",
        "chart-3": "#f7b928",
        "chart-4": "#17bf63",
        "chart-5": "#e0245e",
        sidebar: "#f7f8f8",
        "sidebar-foreground": "#0f1419",
        "sidebar-primary": "#1e9df1",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#E3ECF6",
        "sidebar-accent-foreground": "#1e9df1",
        "sidebar-border": "#e1e8ed",
        "sidebar-ring": "#1da1f2",
        "font-sans": "Open Sans, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Menlo, monospace",
        radius: "1.3rem",
        "shadow-color": "rgba(29,161,242,0.15)",
        "shadow-opacity": "0",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#000000",
        foreground: "#e7e9ea",
        card: "#17181c",
        "card-foreground": "#d9d9d9",
        popover: "#000000",
        "popover-foreground": "#e7e9ea",
        primary: "#1c9cf0",
        "primary-foreground": "#ffffff",
        secondary: "#f0f3f4",
        "secondary-foreground": "#0f1419",
        muted: "#181818",
        "muted-foreground": "#72767a",
        accent: "#061622",
        "accent-foreground": "#1c9cf0",
        destructive: "#f4212e",
        "destructive-foreground": "#ffffff",
        border: "#242628",
        input: "#22303c",
        ring: "#1da1f2",
        "chart-1": "#1e9df1",
        "chart-2": "#00b87a",
        "chart-3": "#f7b928",
        "chart-4": "#17bf63",
        "chart-5": "#e0245e",
        sidebar: "#17181c",
        "sidebar-foreground": "#d9d9d9",
        "sidebar-primary": "#1da1f2",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#061622",
        "sidebar-accent-foreground": "#1c9cf0",
        "sidebar-border": "#38444d",
        "sidebar-ring": "#1da1f2",
        "shadow-color": "rgba(29,161,242,0.25)",
      },
    },
  },

  "mocha-mousse": {
    label: "Mocha Mousse",
    createdAt: "2025-04-24",
    styles: {
      light: {
        background: "#F1F0E5",
        foreground: "#56453F",
        card: "#F1F0E5",
        "card-foreground": "#56453F",
        popover: "#FFFFFF",
        "popover-foreground": "#56453F",
        primary: "#A37764",
        "primary-foreground": "#FFFFFF",
        secondary: "#BAAB92",
        "secondary-foreground": "#ffffff",
        muted: "#E4C7B8",
        "muted-foreground": "#8A655A",
        accent: "#E4C7B8",
        "accent-foreground": "#56453F",
        destructive: "#1f1a17",
        "destructive-foreground": "#FFFFFF",
        border: "#BAAB92",
        input: "#BAAB92",
        ring: "#A37764",
        "chart-1": "#A37764",
        "chart-2": "#8A655A",
        "chart-3": "#C39E88",
        "chart-4": "#BAAB92",
        "chart-5": "#A28777",
        sidebar: "#ebd6cb",
        "sidebar-foreground": "#56453F",
        "sidebar-primary": "#A37764",
        "sidebar-primary-foreground": "#FFFFFF",
        "sidebar-accent": "#C39E88",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#A28777",
        "sidebar-ring": "#A37764",
        "font-sans": "DM Sans, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Menlo, monospace",
        radius: "0.5rem",
        "shadow-color": "hsl(20 18% 51% / 0.4)",
        "shadow-opacity": "0.11",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "2px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#2d2521",
        foreground: "#F1F0E5",
        card: "#3c332e",
        "card-foreground": "#F1F0E5",
        popover: "#3c332e",
        "popover-foreground": "#F1F0E5",
        primary: "#C39E88",
        "primary-foreground": "#2d2521",
        secondary: "#8A655A",
        "secondary-foreground": "#F1F0E5",
        muted: "#56453F",
        "muted-foreground": "#c5aa9b",
        accent: "#BAAB92",
        "accent-foreground": "#2d2521",
        destructive: "#E57373",
        "destructive-foreground": "#2d2521",
        border: "#56453F",
        input: "#56453F",
        ring: "#C39E88",
        "chart-1": "#C39E88",
        "chart-2": "#BAAB92",
        "chart-3": "#A37764",
        "chart-4": "#8A655A",
        "chart-5": "#A28777",
        sidebar: "#1f1a17",
        "sidebar-foreground": "#F1F0E5",
        "sidebar-primary": "#C39E88",
        "sidebar-primary-foreground": "#1f1a17",
        "sidebar-accent": "#BAAB92",
        "sidebar-accent-foreground": "#1f1a17",
        "sidebar-border": "#56453F",
        "sidebar-ring": "#C39E88",
        "shadow-color": "hsl(20 18% 30% / 0.5)",
      },
    },
  },

  bubblegum: {
    label: "Bubblegum",
    createdAt: "2025-04-18",
    styles: {
      light: {
        background: "#f6e6ee",
        foreground: "#5b5b5b",
        card: "#fdedc9",
        "card-foreground": "#5b5b5b",
        popover: "#ffffff",
        "popover-foreground": "#5b5b5b",
        primary: "#d04f99",
        "primary-foreground": "#ffffff",
        secondary: "#8acfd1",
        "secondary-foreground": "#333333",
        muted: "#b2e1eb",
        "muted-foreground": "#7a7a7a",
        accent: "#fbe2a7",
        "accent-foreground": "#333333",
        destructive: "#f96f70",
        "destructive-foreground": "#ffffff",
        border: "#d04f99",
        input: "#e4e4e4",
        ring: "#e670ab",
        "chart-1": "#e670ab",
        "chart-2": "#84d2e2",
        "chart-3": "#fbe2a7",
        "chart-4": "#f3a0ca",
        "chart-5": "#d7488e",
        sidebar: "#f8d8ea",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#ec4899",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#f9a8d4",
        "sidebar-accent-foreground": "#333333",
        "sidebar-border": "#f3e8ff",
        "sidebar-ring": "#ec4899",
        "font-sans": "Poppins, sans-serif",
        "font-serif": "Lora, serif",
        "font-mono": "Fira Code, monospace",
        radius: "0.4rem",
        "shadow-color": "hsl(325.78 58.18% 56.86% / 0.5)",
        "shadow-opacity": "1.0",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "3px",
        "shadow-offset-y": "3px",
      },
      dark: {
        background: "#12242e",
        foreground: "#f3e3ea",
        card: "#1c2e38",
        "card-foreground": "#f3e3ea",
        popover: "#1c2e38",
        "popover-foreground": "#f3e3ea",
        primary: "#fbe2a7",
        "primary-foreground": "#12242e",
        secondary: "#e4a2b1",
        "secondary-foreground": "#12242e",
        muted: "#24272b",
        "muted-foreground": "#e4a2b1",
        accent: "#c67b96",
        "accent-foreground": "#f3e3ea",
        destructive: "#e35ea4",
        "destructive-foreground": "#12242e",
        border: "#324859",
        input: "#20333d",
        ring: "#50afb6",
        "chart-1": "#50afb6",
        "chart-2": "#e4a2b1",
        "chart-3": "#c67b96",
        "chart-4": "#175c6c",
        "chart-5": "#24272b",
        sidebar: "#101f28",
        "sidebar-foreground": "#f3f4f6",
        "sidebar-primary": "#ec4899",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#f9a8d4",
        "sidebar-accent-foreground": "#1f2937",
        "sidebar-border": "#374151",
        "sidebar-ring": "#ec4899",
        "font-sans": "Poppins, sans-serif",
        "font-serif": "Lora, serif",
        "font-mono": "Fira Code, monospace",
        "shadow-color": "#324859",
      },
    },
  },

  "amethyst-haze": {
    label: "Amethyst Haze",
    createdAt: "2025-05-08",
    styles: {
      light: {
        background: "#f8f7fa",
        foreground: "#3d3c4f",
        card: "#ffffff",
        "card-foreground": "#3d3c4f",
        popover: "#ffffff",
        "popover-foreground": "#3d3c4f",
        primary: "#8a79ab",
        "primary-foreground": "#f8f7fa",
        secondary: "#dfd9ec",
        "secondary-foreground": "#3d3c4f",
        muted: "#dcd9e3",
        "muted-foreground": "#6b6880",
        accent: "#e6a5b8",
        "accent-foreground": "#4b2e36",
        destructive: "#d95c5c",
        "destructive-foreground": "#f8f7fa",
        border: "#cec9d9",
        input: "#eae7f0",
        ring: "#8a79ab",
        "chart-1": "#8a79ab",
        "chart-2": "#e6a5b8",
        "chart-3": "#77b8a1",
        "chart-4": "#f0c88d",
        "chart-5": "#a0bbe3",
        sidebar: "#f1eff5",
        "sidebar-foreground": "#3d3c4f",
        "sidebar-primary": "#8a79ab",
        "sidebar-primary-foreground": "#f8f7fa",
        "sidebar-accent": "#e6a5b8",
        "sidebar-accent-foreground": "#4b2e36",
        "sidebar-border": "#d7d2e0",
        "sidebar-ring": "#8a79ab",
        "font-sans": "Geist, sans-serif",
        "font-serif": '"Lora", Georgia, serif',
        "font-mono": '"Fira Code", "Courier New", monospace',
        radius: "0.5rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.06",
        "shadow-blur": "5px",
        "shadow-spread": "1px",
        "shadow-offset-x": "1px",
        "shadow-offset-y": "2px",
        "letter-spacing": "0em",
        spacing: "0.25rem",
      },
      dark: {
        background: "#1a1823",
        foreground: "#e0ddef",
        card: "#232030",
        "card-foreground": "#e0ddef",
        popover: "#232030",
        "popover-foreground": "#e0ddef",
        primary: "#a995c9",
        "primary-foreground": "#1a1823",
        secondary: "#5a5370",
        "secondary-foreground": "#e0ddef",
        muted: "#242031",
        "muted-foreground": "#a09aad",
        accent: "#372e3f",
        "accent-foreground": "#f2b8c6",
        destructive: "#e57373",
        "destructive-foreground": "#1a1823",
        border: "#302c40",
        input: "#2a273a",
        ring: "#a995c9",
        "chart-1": "#a995c9",
        "chart-2": "#f2b8c6",
        "chart-3": "#77b8a1",
        "chart-4": "#f0c88d",
        "chart-5": "#a0bbe3",
        sidebar: "#16141e",
        "sidebar-foreground": "#e0ddef",
        "sidebar-primary": "#a995c9",
        "sidebar-primary-foreground": "#1a1823",
        "sidebar-accent": "#372e3f",
        "sidebar-accent-foreground": "#f2b8c6",
        "sidebar-border": "#2a273a",
        "sidebar-ring": "#a995c9",
      },
    },
  },

  notebook: {
    label: "Notebook",
    createdAt: "2025-05-10",
    styles: {
      light: {
        background: "#f9f9f9",
        foreground: "#3a3a3a",
        card: "#ffffff",
        "card-foreground": "#3a3a3a",
        popover: "#ffffff",
        "popover-foreground": "#3a3a3a",
        primary: "#606060",
        "primary-foreground": "#f0f0f0",
        secondary: "#dedede",
        "secondary-foreground": "#3a3a3a",
        muted: "#e3e3e3",
        "muted-foreground": "#505050",
        accent: "#f3eac8",
        "accent-foreground": "#5d4037",
        destructive: "#c87a7a",
        "destructive-foreground": "#ffffff",
        border: "#747272",
        input: "#ffffff",
        ring: "#a0a0a0",
        "chart-1": "#333333",
        "chart-2": "#555555",
        "chart-3": "#777777",
        "chart-4": "#999999",
        "chart-5": "#bbbbbb",
        sidebar: "#f0f0f0",
        "sidebar-foreground": "#3a3a3a",
        "sidebar-primary": "#606060",
        "sidebar-primary-foreground": "#f0f0f0",
        "sidebar-accent": "#f3eac8",
        "sidebar-accent-foreground": "#5d4037",
        "sidebar-border": "#c0c0c0",
        "sidebar-ring": "#a0a0a0",
        "font-sans": "Architects Daughter, sans-serif",
        "font-serif": '"Times New Roman", Times, serif',
        "font-mono": '"Courier New", Courier, monospace',
        radius: "0.625rem",
        "shadow-color": "#000000",
        "shadow-opacity": "0.03",
        "shadow-blur": "5px",
        "shadow-spread": "0px",
        "shadow-offset-x": "1px",
        "shadow-offset-y": "4px",
        "letter-spacing": "0.5px",
        spacing: "0.25rem",
      },
      dark: {
        background: "#2b2b2b",
        foreground: "#dcdcdc",
        card: "#333333",
        "card-foreground": "#dcdcdc",
        popover: "#333333",
        "popover-foreground": "#dcdcdc",
        primary: "#b0b0b0",
        "primary-foreground": "#2b2b2b",
        secondary: "#5a5a5a",
        "secondary-foreground": "#c0c0c0",
        muted: "#454545",
        "muted-foreground": "#a0a0a0",
        accent: "#e0e0e0",
        "accent-foreground": "#333333",
        destructive: "#d9afaf",
        "destructive-foreground": "#2b2b2b",
        border: "#4f4f4f",
        input: "#333333",
        ring: "#c0c0c0",
        "chart-1": "#efefef",
        "chart-2": "#d0d0d0",
        "chart-3": "#b0b0b0",
        "chart-4": "#909090",
        "chart-5": "#707070",
        sidebar: "#212121",
        "sidebar-foreground": "#dcdcdc",
        "sidebar-primary": "#b0b0b0",
        "sidebar-primary-foreground": "#212121",
        "sidebar-accent": "#e0e0e0",
        "sidebar-accent-foreground": "#333333",
        "sidebar-border": "#4f4f4f",
        "sidebar-ring": "#c0c0c0",
        "font-sans": "Architects Daughter, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": '"Fira Code", "Courier New", monospace',
        radius: "0.625rem",
        "shadow-color": "#000000",
        "shadow-opacity": "0.03",
        "shadow-blur": "5px",
        "shadow-spread": "0px",
        "shadow-offset-x": "1px",
        "shadow-offset-y": "4px",
        "letter-spacing": "0.5px",
        spacing: "0.25rem",
      },
    },
  },

  "doom-64": {
    label: "Doom 64",
    createdAt: "2025-04-28",
    styles: {
      light: {
        background: "#cccccc",
        foreground: "#1f1f1f",
        card: "#b0b0b0",
        "card-foreground": "#1f1f1f",
        popover: "#b0b0b0",
        "popover-foreground": "#1f1f1f",
        primary: "#b71c1c",
        "primary-foreground": "#ffffff",
        secondary: "#556b2f",
        "secondary-foreground": "#ffffff",
        muted: "#b8b8b8",
        "muted-foreground": "#4a4a4a",
        accent: "#4682b4",
        "accent-foreground": "#ffffff",
        destructive: "#ff6f00",
        "destructive-foreground": "#000000",
        border: "#505050",
        input: "#505050",
        ring: "#b71c1c",
        "chart-1": "#b71c1c",
        "chart-2": "#556b2f",
        "chart-3": "#4682b4",
        "chart-4": "#ff6f00",
        "chart-5": "#8d6e63",
        sidebar: "#b0b0b0",
        "sidebar-foreground": "#1f1f1f",
        "sidebar-primary": "#b71c1c",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#4682b4",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#505050",
        "sidebar-ring": "#b71c1c",
        "font-sans": '"Oxanium", sans-serif',
        "font-serif": 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
        "font-mono": '"Source Code Pro", monospace',
        radius: "0px",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.4",
        "shadow-blur": "4px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
        "letter-spacing": "0em",
        spacing: "0.25rem",
      },
      dark: {
        background: "#1a1a1a",
        foreground: "#e0e0e0",
        card: "#2a2a2a",
        "card-foreground": "#e0e0e0",
        popover: "#2a2a2a",
        "popover-foreground": "#e0e0e0",
        primary: "#e53935",
        "primary-foreground": "#ffffff",
        secondary: "#689f38",
        "secondary-foreground": "#000000",
        muted: "#252525",
        "muted-foreground": "#a0a0a0",
        accent: "#64b5f6",
        "accent-foreground": "#000000",
        destructive: "#ffa000",
        "destructive-foreground": "#000000",
        border: "#4a4a4a",
        input: "#4a4a4a",
        ring: "#e53935",
        "chart-1": "#e53935",
        "chart-2": "#689f38",
        "chart-3": "#64b5f6",
        "chart-4": "#ffa000",
        "chart-5": "#a1887f",
        sidebar: "#141414",
        "sidebar-foreground": "#e0e0e0",
        "sidebar-primary": "#e53935",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#64b5f6",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#4a4a4a",
        "sidebar-ring": "#e53935",
        "font-sans": '"Oxanium", sans-serif',
        "font-serif": 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
        "font-mono": '"Source Code Pro", monospace',
        radius: "0px",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.6",
        "shadow-blur": "5px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
        "letter-spacing": "0em",
        spacing: "0.25rem",
      },
    },
  },

  catppuccin: {
    label: "Catppuccin",
    createdAt: "2025-04-18",
    styles: {
      light: {
        background: "#eff1f5",
        foreground: "#4c4f69",
        card: "#ffffff",
        "card-foreground": "#4c4f69",
        popover: "#ccd0da",
        "popover-foreground": "#4c4f69",
        primary: "#8839ef",
        "primary-foreground": "#ffffff",
        secondary: "#ccd0da",
        "secondary-foreground": "#4c4f69",
        muted: "#dce0e8",
        "muted-foreground": "#6c6f85",
        accent: "#04a5e5",
        "accent-foreground": "#ffffff",
        destructive: "#d20f39",
        "destructive-foreground": "#ffffff",
        border: "#bcc0cc",
        input: "#ccd0da",
        ring: "#8839ef",
        "chart-1": "#8839ef",
        "chart-2": "#04a5e5",
        "chart-3": "#40a02b",
        "chart-4": "#fe640b",
        "chart-5": "#dc8a78",
        sidebar: "#e6e9ef",
        "sidebar-foreground": "#4c4f69",
        "sidebar-primary": "#8839ef",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#04a5e5",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#bcc0cc",
        "sidebar-ring": "#8839ef",
        "font-sans": "Montserrat, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Fira Code, monospace",
        radius: "0.35rem",
        "shadow-color": "hsl(240 30% 25%)",
        "shadow-opacity": "0.12",
        "shadow-blur": "6px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "4px",
      },
      dark: {
        background: "#181825",
        foreground: "#cdd6f4",
        card: "#1e1e2e",
        "card-foreground": "#cdd6f4",
        popover: "#45475a",
        "popover-foreground": "#cdd6f4",
        primary: "#cba6f7",
        "primary-foreground": "#1e1e2e",
        secondary: "#585b70",
        "secondary-foreground": "#cdd6f4",
        muted: "#292c3c",
        "muted-foreground": "#a6adc8",
        accent: "#89dceb",
        "accent-foreground": "#1e1e2e",
        destructive: "#f38ba8",
        "destructive-foreground": "#1e1e2e",
        border: "#313244",
        input: "#313244",
        ring: "#cba6f7",
        "chart-1": "#cba6f7",
        "chart-2": "#89dceb",
        "chart-3": "#a6e3a1",
        "chart-4": "#fab387",
        "chart-5": "#f5e0dc",
        sidebar: "#11111b",
        "sidebar-foreground": "#cdd6f4",
        "sidebar-primary": "#cba6f7",
        "sidebar-primary-foreground": "#1e1e2e",
        "sidebar-accent": "#89dceb",
        "sidebar-accent-foreground": "#1e1e2e",
        "sidebar-border": "#45475a",
        "sidebar-ring": "#cba6f7",
      },
    },
  },

  graphite: {
    label: "Graphite",
    createdAt: "2025-04-17",
    styles: {
      light: {
        background: "#f0f0f0",
        foreground: "#333333",
        card: "#f5f5f5",
        "card-foreground": "#333333",
        popover: "#f5f5f5",
        "popover-foreground": "#333333",
        primary: "#606060",
        "primary-foreground": "#ffffff",
        secondary: "#e0e0e0",
        "secondary-foreground": "#333333",
        muted: "#d9d9d9",
        "muted-foreground": "#666666",
        accent: "#c0c0c0",
        "accent-foreground": "#333333",
        destructive: "#cc3333",
        "destructive-foreground": "#ffffff",
        border: "#d0d0d0",
        input: "#e0e0e0",
        ring: "#606060",
        "chart-1": "#606060",
        "chart-2": "#476666",
        "chart-3": "#909090",
        "chart-4": "#a8a8a8",
        "chart-5": "#c0c0c0",
        sidebar: "#eaeaea",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#606060",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#c0c0c0",
        "sidebar-accent-foreground": "#333333",
        "sidebar-border": "#d0d0d0",
        "sidebar-ring": "#606060",
        "font-sans": "Montserrat, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Fira Code, monospace",
        radius: "0.35rem",
        "shadow-color": "hsl(0 0% 20% / 0.1)",
        "shadow-opacity": "0.15",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#1a1a1a",
        foreground: "#d9d9d9",
        card: "#202020",
        "card-foreground": "#d9d9d9",
        popover: "#202020",
        "popover-foreground": "#d9d9d9",
        primary: "#a0a0a0",
        "primary-foreground": "#1a1a1a",
        secondary: "#303030",
        "secondary-foreground": "#d9d9d9",
        muted: "#2a2a2a",
        "muted-foreground": "#808080",
        accent: "#404040",
        "accent-foreground": "#d9d9d9",
        destructive: "#e06666",
        "destructive-foreground": "#ffffff",
        border: "#353535",
        input: "#303030",
        ring: "#a0a0a0",
        "chart-1": "#a0a0a0",
        "chart-2": "#7e9ca0",
        "chart-3": "#707070",
        "chart-4": "#585858",
        "chart-5": "#404040",
        sidebar: "#1f1f1f",
        "sidebar-foreground": "#d9d9d9",
        "sidebar-primary": "#a0a0a0",
        "sidebar-primary-foreground": "#1a1a1a",
        "sidebar-accent": "#404040",
        "sidebar-accent-foreground": "#d9d9d9",
        "sidebar-border": "#353535",
        "sidebar-ring": "#a0a0a0",
        "font-sans": "Inter, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Fira Code, monospace",
      },
    },
  },

  perpetuity: {
    label: "Perpetuity",
    createdAt: "2025-04-01",
    styles: {
      light: {
        background: "#e8f0f0",
        foreground: "#0a4a55",
        card: "#f2f7f7",
        "card-foreground": "#0a4a55",
        popover: "#f2f7f7",
        "popover-foreground": "#0a4a55",
        primary: "#06858e",
        "primary-foreground": "#ffffff",
        secondary: "#d9eaea",
        "secondary-foreground": "#0a4a55",
        muted: "#e0eaea",
        "muted-foreground": "#427a7e",
        accent: "#c9e5e7",
        "accent-foreground": "#0a4a55",
        destructive: "#d13838",
        "destructive-foreground": "#ffffff",
        border: "#cde0e2",
        input: "#d9eaea",
        ring: "#06858e",
        "chart-1": "#06858e",
        "chart-2": "#1e9ea6",
        "chart-3": "#37b6be",
        "chart-4": "#5dc7ce",
        "chart-5": "#8ad8dd",
        sidebar: "#daebed",
        "sidebar-foreground": "#0a4a55",
        "sidebar-primary": "#06858e",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#c9e5e7",
        "sidebar-accent-foreground": "#0a4a55",
        "sidebar-border": "#cde0e2",
        "sidebar-ring": "#06858e",
        "font-sans": "Courier New, monospace",
        "font-serif": "Courier New, monospace",
        "font-mono": "Courier New, monospace",
        radius: "0.125rem",
        "shadow-color": "hsl(185 70% 30% / 0.15)",
        "shadow-opacity": "0.15",
        "shadow-blur": "2px",
        "shadow-spread": "0px",
        "shadow-offset-x": "1px",
        "shadow-offset-y": "1px",
      },
      dark: {
        background: "#0a1a20",
        foreground: "#4de8e8",
        card: "#0c2025",
        "card-foreground": "#4de8e8",
        popover: "#0c2025",
        "popover-foreground": "#4de8e8",
        primary: "#4de8e8",
        "primary-foreground": "#0a1a20",
        secondary: "#164955",
        "secondary-foreground": "#4de8e8",
        muted: "#0f3039",
        "muted-foreground": "#36a5a5",
        accent: "#164955",
        "accent-foreground": "#4de8e8",
        destructive: "#e83c3c",
        "destructive-foreground": "#f2f2f2",
        border: "#164955",
        input: "#164955",
        ring: "#4de8e8",
        "chart-1": "#4de8e8",
        "chart-2": "#36a5a5",
        "chart-3": "#2d8a8a",
        "chart-4": "#19595e",
        "chart-5": "#0e383c",
        sidebar: "#0a1a20",
        "sidebar-foreground": "#4de8e8",
        "sidebar-primary": "#4de8e8",
        "sidebar-primary-foreground": "#0a1a20",
        "sidebar-accent": "#164955",
        "sidebar-accent-foreground": "#4de8e8",
        "sidebar-border": "#164955",
        "sidebar-ring": "#4de8e8",
        "font-sans": "Source Code Pro, monospace",
        "font-serif": "Source Code Pro, monospace",
        "font-mono": "Source Code Pro, monospace",
        radius: "0.125rem",
        "shadow-color": "hsl(180 70% 60% / 0.2)",
        "shadow-opacity": "0.2",
        "shadow-blur": "2px",
        "shadow-spread": "0px",
        "shadow-offset-x": "1px",
        "shadow-offset-y": "1px",
      },
    },
  },
  "kodama-grove": {
    label: "Kodama Grove",
    styles: {
      light: {
        background: "#e4d7b0",
        foreground: "#5c4b3e",
        card: "#e7dbbf",
        "card-foreground": "#5c4b3e",
        popover: "#f3ead2",
        "popover-foreground": "#5c4b3e",
        primary: "#8d9d4f",
        "primary-foreground": "#fdfbf6",
        secondary: "#decea0",
        "secondary-foreground": "#5c4b3e",
        muted: "#decea0",
        "muted-foreground": "#85766a",
        accent: "#dbc894",
        "accent-foreground": "#5c4b3e",
        destructive: "#d98b7e",
        "destructive-foreground": "#faf8f2",
        border: "#b19681",
        input: "#dbc894",
        ring: "#9db18c",
        "chart-1": "#9db18c",
        "chart-2": "#8a9f7b",
        "chart-3": "#bac9b4",
        "chart-4": "#71856a",
        "chart-5": "#5e6e58",
        sidebar: "#e2d1a2",
        "sidebar-foreground": "#5c4b3e",
        "sidebar-primary": "#9db18c",
        "sidebar-primary-foreground": "#fdfbf6",
        "sidebar-accent": "#eae5d9",
        "sidebar-accent-foreground": "#5c4b3e",
        "sidebar-border": "#e5e0d4",
        "sidebar-ring": "#9db18c",
        "font-sans": "Merriweather, serif",
        "font-serif": "Source Serif 4, serif",
        "font-mono": "JetBrains Mono, monospace",
        radius: "0.425rem",
        "shadow-color": "hsl(88 22% 35% / 0.15)",
        "shadow-opacity": "0.15",
        "shadow-blur": "2px",
        "shadow-spread": "0px",
        "shadow-offset-x": "3px",
        "shadow-offset-y": "3px",
      },
      dark: {
        background: "#3a3529",
        foreground: "#ede4d4",
        card: "#413c33",
        "card-foreground": "#ede4d4",
        popover: "#413c33",
        "popover-foreground": "#ede4d4",
        primary: "#8a9f7b",
        "primary-foreground": "#2a2521",
        secondary: "#5a5345",
        "secondary-foreground": "#ede4d4",
        muted: "#4a4439",
        "muted-foreground": "#a8a096",
        accent: "#a18f5c",
        "accent-foreground": "#2a2521",
        destructive: "#b5766a",
        "destructive-foreground": "#f0e9db",
        border: "#5a5345",
        input: "#5a5345",
        ring: "#8a9f7b",
        "chart-1": "#8a9f7b",
        "chart-2": "#9db18c",
        "chart-3": "#71856a",
        "chart-4": "#a18f5c",
        "chart-5": "#5e6e58",
        sidebar: "#3a3529",
        "sidebar-foreground": "#ede4d4",
        "sidebar-primary": "#8a9f7b",
        "sidebar-primary-foreground": "#2a2521",
        "sidebar-accent": "#a18f5c",
        "sidebar-accent-foreground": "#2a2521",
        "sidebar-border": "#5a5345",
        "sidebar-ring": "#8a9f7b",
      },
    },
  },

  "cosmic-night": {
    label: "Cosmic Night",
    createdAt: "2025-04-04",
    styles: {
      light: {
        background: "#f5f5ff",
        foreground: "#2a2a4a",
        card: "#ffffff",
        "card-foreground": "#2a2a4a",
        popover: "#ffffff",
        "popover-foreground": "#2a2a4a",
        primary: "#6e56cf",
        "primary-foreground": "#ffffff",
        secondary: "#e4dfff",
        "secondary-foreground": "#4a4080",
        muted: "#f0f0fa",
        "muted-foreground": "#6c6c8a",
        accent: "#d8e6ff",
        "accent-foreground": "#2a2a4a",
        destructive: "#ff5470",
        "destructive-foreground": "#ffffff",
        border: "#e0e0f0",
        input: "#e0e0f0",
        ring: "#6e56cf",
        "chart-1": "#6e56cf",
        "chart-2": "#9e8cfc",
        "chart-3": "#5d5fef",
        "chart-4": "#7c75fa",
        "chart-5": "#4740b3",
        radius: "0.5rem",
        sidebar: "#f0f0fa",
        "sidebar-foreground": "#2a2a4a",
        "sidebar-primary": "#6e56cf",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#d8e6ff",
        "sidebar-accent-foreground": "#2a2a4a",
        "sidebar-border": "#e0e0f0",
        "sidebar-ring": "#6e56cf",
        "font-sans": "Inter, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "JetBrains Mono, monospace",
        "shadow-color": "hsl(240 30% 25%)",
        "shadow-opacity": "0.12",
        "shadow-blur": "10px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "4px",
      },
      dark: {
        background: "#0f0f1a",
        foreground: "#e2e2f5",
        card: "#1a1a2e",
        "card-foreground": "#e2e2f5",
        popover: "#1a1a2e",
        "popover-foreground": "#e2e2f5",
        primary: "#a48fff",
        "primary-foreground": "#0f0f1a",
        secondary: "#2d2b55",
        "secondary-foreground": "#c4c2ff",
        muted: "#222244",
        "muted-foreground": "#a0a0c0",
        accent: "#303060",
        "accent-foreground": "#e2e2f5",
        destructive: "#ff5470",
        "destructive-foreground": "#ffffff",
        border: "#303052",
        input: "#303052",
        ring: "#a48fff",
        "chart-1": "#a48fff",
        "chart-2": "#7986cb",
        "chart-3": "#64b5f6",
        "chart-4": "#4db6ac",
        "chart-5": "#ff79c6",
        radius: "0.5rem",
        sidebar: "#1a1a2e",
        "sidebar-foreground": "#e2e2f5",
        "sidebar-primary": "#a48fff",
        "sidebar-primary-foreground": "#0f0f1a",
        "sidebar-accent": "#303060",
        "sidebar-accent-foreground": "#e2e2f5",
        "sidebar-border": "#303052",
        "sidebar-ring": "#a48fff",
      },
    },
  },

  tangerine: {
    label: "Tangerine",
    createdAt: "2025-04-09",
    styles: {
      light: {
        background: "#e8ebed",
        foreground: "#333333",
        card: "#ffffff",
        "card-foreground": "#333333",
        popover: "#ffffff",
        "popover-foreground": "#333333",
        primary: "#e05d38",
        "primary-foreground": "#ffffff",
        secondary: "#f3f4f6",
        "secondary-foreground": "#4b5563",
        muted: "#f9fafb",
        "muted-foreground": "#6b7280",
        accent: "#d6e4f0",
        "accent-foreground": "#1e3a8a",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#dcdfe2",
        input: "#f4f5f7",
        ring: "#e05d38",
        "chart-1": "#86a7c8",
        "chart-2": "#eea591",
        "chart-3": "#5a7ca6",
        "chart-4": "#466494",
        "chart-5": "#334c82",
        sidebar: "#dddfe2",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#e05d38",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#d6e4f0",
        "sidebar-accent-foreground": "#1e3a8a",
        "sidebar-border": "#e5e7eb",
        "sidebar-ring": "#e05d38",
        "font-sans": "Inter, sans-serif",
        "font-serif": "Source Serif 4, serif",
        "font-mono": "JetBrains Mono, monospace",
        radius: "0.75rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.1",
        "shadow-blur": "3px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "1px",
      },
      dark: {
        background: "#1c2433",
        foreground: "#e5e5e5",
        card: "#2a3040",
        "card-foreground": "#e5e5e5",
        popover: "#262b38",
        "popover-foreground": "#e5e5e5",
        primary: "#e05d38",
        "primary-foreground": "#ffffff",
        secondary: "#2a303e",
        "secondary-foreground": "#e5e5e5",
        muted: "#2a303e",
        "muted-foreground": "#a3a3a3",
        accent: "#2a3656",
        "accent-foreground": "#bfdbfe",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#3d4354",
        input: "#3d4354",
        ring: "#e05d38",
        "chart-1": "#86a7c8",
        "chart-2": "#e6a08f",
        "chart-3": "#5a7ca6",
        "chart-4": "#466494",
        "chart-5": "#334c82",
        sidebar: "#2a303f",
        "sidebar-foreground": "#e5e5e5",
        "sidebar-primary": "#e05d38",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#2a3656",
        "sidebar-accent-foreground": "#bfdbfe",
        "sidebar-border": "#3d4354",
        "sidebar-ring": "#e05d38",
      },
    },
  },

  "quantum-rose": {
    label: "Quantum Rose",
    createdAt: "2025-04-03",
    styles: {
      light: {
        background: "#fff0f8",
        foreground: "#91185c",
        card: "#fff7fc",
        "card-foreground": "#91185c",
        popover: "#fff7fc",
        "popover-foreground": "#91185c",
        primary: "#e6067a",
        "primary-foreground": "#ffffff",
        secondary: "#ffd6ff",
        "secondary-foreground": "#91185c",
        muted: "#ffe3f2",
        "muted-foreground": "#c04283",
        accent: "#ffc1e3",
        "accent-foreground": "#91185c",
        destructive: "#d13869",
        "destructive-foreground": "#ffffff",
        border: "#ffc7e6",
        input: "#ffd6ff",
        ring: "#e6067a",
        "chart-1": "#e6067a",
        "chart-2": "#c44b97",
        "chart-3": "#9969b6",
        "chart-4": "#7371bf",
        "chart-5": "#5e84ff",
        sidebar: "#ffedf6",
        "sidebar-foreground": "#91185c",
        "sidebar-primary": "#e6067a",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#ffc1e3",
        "sidebar-accent-foreground": "#91185c",
        "sidebar-border": "#ffddf0",
        "sidebar-ring": "#e6067a",
        "font-sans": "Poppins, sans-serif",
        "font-serif": "Playfair Display, serif",
        "font-mono": "Space Mono, monospace",
        radius: "0.5rem",
        "shadow-color": "hsl(330 70% 30% / 0.12)",
        "shadow-opacity": "0.18",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "3px",
      },
      dark: {
        background: "#1a0922",
        foreground: "#ffb3ff",
        card: "#2a1435",
        "card-foreground": "#ffb3ff",
        popover: "#2a1435",
        "popover-foreground": "#ffb3ff",
        primary: "#ff6bef",
        "primary-foreground": "#180518",
        secondary: "#46204f",
        "secondary-foreground": "#ffb3ff",
        muted: "#331941",
        "muted-foreground": "#d67ad6",
        accent: "#5a1f5d",
        "accent-foreground": "#ffb3ff",
        destructive: "#ff2876",
        "destructive-foreground": "#f9f9f9",
        border: "#4a1b5f",
        input: "#46204f",
        ring: "#ff6bef",
        "chart-1": "#ff6bef",
        "chart-2": "#c359e3",
        "chart-3": "#9161ff",
        "chart-4": "#6f73e2",
        "chart-5": "#547aff",
        sidebar: "#1c0d25",
        "sidebar-foreground": "#ffb3ff",
        "sidebar-primary": "#ff6bef",
        "sidebar-primary-foreground": "#180518",
        "sidebar-accent": "#5a1f5d",
        "sidebar-accent-foreground": "#ffb3ff",
        "sidebar-border": "#4a1b5f",
        "sidebar-ring": "#ff6bef",
        "font-sans": "Quicksand, sans-serif",
        "font-serif": "Playfair Display, serif",
        "font-mono": "Space Mono, monospace",
        "shadow-color": "hsl(300 80% 50% / 0.25)",
      },
    },
  },

  nature: {
    label: "Nature",
    styles: {
      light: {
        background: "#f8f5f0",
        foreground: "#3e2723",
        card: "#f8f5f0",
        "card-foreground": "#3e2723",
        popover: "#f8f5f0",
        "popover-foreground": "#3e2723",
        primary: "#2e7d32",
        "primary-foreground": "#ffffff",
        secondary: "#e8f5e9",
        "secondary-foreground": "#1b5e20",
        muted: "#f0e9e0",
        "muted-foreground": "#6d4c41",
        accent: "#c8e6c9",
        "accent-foreground": "#1b5e20",
        destructive: "#c62828",
        "destructive-foreground": "#ffffff",
        border: "#e0d6c9",
        input: "#e0d6c9",
        ring: "#2e7d32",
        "chart-1": "#4caf50",
        "chart-2": "#388e3c",
        "chart-3": "#2e7d32",
        "chart-4": "#1b5e20",
        "chart-5": "#0a1f0c",
        radius: "0.5rem",
        sidebar: "#f0e9e0",
        "sidebar-foreground": "#3e2723",
        "sidebar-primary": "#2e7d32",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#c8e6c9",
        "sidebar-accent-foreground": "#1b5e20",
        "sidebar-border": "#e0d6c9",
        "sidebar-ring": "#2e7d32",
        "font-sans": "Montserrat, sans-serif",
        "font-serif": "Merriweather, serif",
        "font-mono": "Source Code Pro, monospace",
      },
      dark: {
        background: "#1c2a1f",
        foreground: "#f0ebe5",
        card: "#2d3a2e",
        "card-foreground": "#f0ebe5",
        popover: "#2d3a2e",
        "popover-foreground": "#f0ebe5",
        primary: "#4caf50",
        "primary-foreground": "#0a1f0c",
        secondary: "#3e4a3d",
        "secondary-foreground": "#d7e0d6",
        muted: "#2d3a2e",
        "muted-foreground": "#d7cfc4",
        accent: "#388e3c",
        "accent-foreground": "#f0ebe5",
        destructive: "#c62828",
        "destructive-foreground": "#f0ebe5",
        border: "#3e4a3d",
        input: "#3e4a3d",
        ring: "#4caf50",
        "chart-1": "#81c784",
        "chart-2": "#66bb6a",
        "chart-3": "#4caf50",
        "chart-4": "#43a047",
        "chart-5": "#388e3c",
        radius: "0.5rem",
        sidebar: "#1c2a1f",
        "sidebar-foreground": "#f0ebe5",
        "sidebar-primary": "#4caf50",
        "sidebar-primary-foreground": "#0a1f0c",
        "sidebar-accent": "#388e3c",
        "sidebar-accent-foreground": "#f0ebe5",
        "sidebar-border": "#3e4a3d",
        "sidebar-ring": "#4caf50",
      },
    },
  },

  "bold-tech": {
    label: "Bold Tech",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#312e81",
        card: "#ffffff",
        "card-foreground": "#312e81",
        popover: "#ffffff",
        "popover-foreground": "#312e81",
        primary: "#8b5cf6",
        "primary-foreground": "#ffffff",
        secondary: "#f3f0ff",
        "secondary-foreground": "#4338ca",
        muted: "#f5f3ff",
        "muted-foreground": "#7c3aed",
        accent: "#dbeafe",
        "accent-foreground": "#1e40af",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#e0e7ff",
        input: "#e0e7ff",
        ring: "#8b5cf6",
        "chart-1": "#8b5cf6",
        "chart-2": "#7c3aed",
        "chart-3": "#6d28d9",
        "chart-4": "#5b21b6",
        "chart-5": "#4c1d95",
        radius: "0.625rem",
        sidebar: "#f5f3ff",
        "sidebar-foreground": "#312e81",
        "sidebar-primary": "#8b5cf6",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#dbeafe",
        "sidebar-accent-foreground": "#1e40af",
        "sidebar-border": "#e0e7ff",
        "sidebar-ring": "#8b5cf6",
        "font-sans": "Roboto, sans-serif",
        "font-serif": "Playfair Display, serif",
        "font-mono": "Fira Code, monospace",
        "shadow-color": "hsl(255 86% 66%)",
        "shadow-opacity": "0.2",
        "shadow-blur": "4px",
        "shadow-spread": "0px",
        "shadow-offset-x": "2px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#0f172a",
        foreground: "#e0e7ff",
        card: "#1e1b4b",
        "card-foreground": "#e0e7ff",
        popover: "#1e1b4b",
        "popover-foreground": "#e0e7ff",
        primary: "#8b5cf6",
        "primary-foreground": "#ffffff",
        secondary: "#1e1b4b",
        "secondary-foreground": "#e0e7ff",
        muted: "#1e1b4b",
        "muted-foreground": "#c4b5fd",
        accent: "#4338ca",
        "accent-foreground": "#e0e7ff",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#2e1065",
        input: "#2e1065",
        ring: "#8b5cf6",
        "chart-1": "#a78bfa",
        "chart-2": "#8b5cf6",
        "chart-3": "#7c3aed",
        "chart-4": "#6d28d9",
        "chart-5": "#5b21b6",
        radius: "0.625rem",
        sidebar: "#0f172a",
        "sidebar-foreground": "#e0e7ff",
        "sidebar-primary": "#8b5cf6",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#4338ca",
        "sidebar-accent-foreground": "#e0e7ff",
        "sidebar-border": "#2e1065",
        "sidebar-ring": "#8b5cf6",
      },
    },
  },

  "elegant-luxury": {
    label: "Elegant Luxury",
    styles: {
      light: {
        background: "#faf7f5",
        foreground: "#1a1a1a",
        card: "#faf7f5",
        "card-foreground": "#1a1a1a",
        popover: "#faf7f5",
        "popover-foreground": "#1a1a1a",
        primary: "#9b2c2c",
        "primary-foreground": "#ffffff",
        secondary: "#fdf2d6",
        "secondary-foreground": "#805500",
        muted: "#f0ebe8",
        "muted-foreground": "#57534e",
        accent: "#fef3c7",
        "accent-foreground": "#7f1d1d",
        destructive: "#991b1b",
        "destructive-foreground": "#ffffff",
        border: "#f5e8d2",
        input: "#f5e8d2",
        ring: "#9b2c2c",
        "chart-1": "#b91c1c",
        "chart-2": "#9b2c2c",
        "chart-3": "#7f1d1d",
        "chart-4": "#b45309",
        "chart-5": "#92400e",
        radius: "0.375rem",
        sidebar: "#f0ebe8",
        "sidebar-foreground": "#1a1a1a",
        "sidebar-primary": "#9b2c2c",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#fef3c7",
        "sidebar-accent-foreground": "#7f1d1d",
        "sidebar-border": "#f5e8d2",
        "sidebar-ring": "#9b2c2c",
        "font-sans": "Poppins, sans-serif",
        "font-serif": "Libre Baskerville, serif",
        "font-mono": "IBM Plex Mono, monospace",
        "shadow-color": "hsl(0 63% 18%)",
        "shadow-opacity": "0.12",
        "shadow-blur": "16px",
        "shadow-spread": "-2px",
        "shadow-offset-x": "1px",
        "shadow-offset-y": "1px",
      },
      dark: {
        background: "#1c1917",
        foreground: "#f5f5f4",
        card: "#292524",
        "card-foreground": "#f5f5f4",
        popover: "#292524",
        "popover-foreground": "#f5f5f4",
        primary: "#b91c1c",
        "primary-foreground": "#faf7f5",
        secondary: "#92400e",
        "secondary-foreground": "#fef3c7",
        muted: "#292524",
        "muted-foreground": "#d6d3d1",
        accent: "#b45309",
        "accent-foreground": "#fef3c7",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#44403c",
        input: "#44403c",
        ring: "#b91c1c",
        "chart-1": "#f87171",
        "chart-2": "#ef4444",
        "chart-3": "#dc2626",
        "chart-4": "#fbbf24",
        "chart-5": "#f59e0b",
        radius: "0.375rem",
        sidebar: "#1c1917",
        "sidebar-foreground": "#f5f5f4",
        "sidebar-primary": "#b91c1c",
        "sidebar-primary-foreground": "#faf7f5",
        "sidebar-accent": "#b45309",
        "sidebar-accent-foreground": "#fef3c7",
        "sidebar-border": "#44403c",
        "sidebar-ring": "#b91c1c",
      },
    },
  },

  "amber-minimal": {
    label: "Amber Minimal",
    createdAt: "2025-04-27",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#262626",
        card: "#ffffff",
        "card-foreground": "#262626",
        popover: "#ffffff",
        "popover-foreground": "#262626",
        primary: "#f59e0b",
        "primary-foreground": "#000000",
        secondary: "#f3f4f6",
        "secondary-foreground": "#4b5563",
        muted: "#f9fafb",
        "muted-foreground": "#6b7280",
        accent: "#fffbeb",
        "accent-foreground": "#92400e",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#e5e7eb",
        input: "#e5e7eb",
        ring: "#f59e0b",
        "chart-1": "#f59e0b",
        "chart-2": "#d97706",
        "chart-3": "#b45309",
        "chart-4": "#92400e",
        "chart-5": "#78350f",
        sidebar: "#f9fafb",
        "sidebar-foreground": "#262626",
        "sidebar-primary": "#f59e0b",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#fffbeb",
        "sidebar-accent-foreground": "#92400e",
        "sidebar-border": "#e5e7eb",
        "sidebar-ring": "#f59e0b",
        "font-sans": "Inter, sans-serif",
        "font-serif": "Source Serif 4, serif",
        "font-mono": "JetBrains Mono, monospace",
        radius: "0.375rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.1",
        "shadow-blur": "8px",
        "shadow-spread": "-1px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "4px",
        "letter-spacing": "0em",
        spacing: "0.25rem",
      },
      dark: {
        background: "#171717",
        foreground: "#e5e5e5",
        card: "#262626",
        "card-foreground": "#e5e5e5",
        popover: "#262626",
        "popover-foreground": "#e5e5e5",
        primary: "#f59e0b",
        "primary-foreground": "#000000",
        secondary: "#262626",
        "secondary-foreground": "#e5e5e5",
        muted: "#262626",
        "muted-foreground": "#a3a3a3",
        accent: "#92400e",
        "accent-foreground": "#fde68a",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#404040",
        input: "#404040",
        ring: "#f59e0b",
        "chart-1": "#fbbf24",
        "chart-2": "#d97706",
        "chart-3": "#92400e",
        "chart-4": "#b45309",
        "chart-5": "#92400e",
        sidebar: "#0f0f0f",
        "sidebar-foreground": "#e5e5e5",
        "sidebar-primary": "#f59e0b",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#92400e",
        "sidebar-accent-foreground": "#fde68a",
        "sidebar-border": "#404040",
        "sidebar-ring": "#f59e0b",
      },
    },
  },

  supabase: {
    label: "Supabase",
    createdAt: "2025-04-27",
    styles: {
      light: {
        background: "#fcfcfc",
        foreground: "#171717",
        card: "#fcfcfc",
        "card-foreground": "#171717",
        popover: "#fcfcfc",
        "popover-foreground": "#525252",
        primary: "#72e3ad",
        "primary-foreground": "#1e2723",
        secondary: "#fdfdfd",
        "secondary-foreground": "#171717",
        muted: "#ededed",
        "muted-foreground": "#202020",
        accent: "#ededed",
        "accent-foreground": "#202020",
        destructive: "#ca3214",
        "destructive-foreground": "#fffcfc",
        border: "#dfdfdf",
        input: "#f6f6f6",
        ring: "#72e3ad",
        "chart-1": "#72e3ad",
        "chart-2": "#3b82f6",
        "chart-3": "#8b5cf6",
        "chart-4": "#f59e0b",
        "chart-5": "#10b981",
        sidebar: "#fcfcfc",
        "sidebar-foreground": "#707070",
        "sidebar-primary": "#72e3ad",
        "sidebar-primary-foreground": "#1e2723",
        "sidebar-accent": "#ededed",
        "sidebar-accent-foreground": "#202020",
        "sidebar-border": "#dfdfdf",
        "sidebar-ring": "#72e3ad",
        "font-sans": "Outfit, sans-serif",
        "font-serif": 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
        "font-mono": "monospace",
        radius: "0.5rem",
        "shadow-color": "#000000",
        "shadow-opacity": "0.17",
        "shadow-blur": "3px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "1px",
        "letter-spacing": "0.025em",
      },
      dark: {
        background: "#121212",
        foreground: "#e2e8f0",
        card: "#171717",
        "card-foreground": "#e2e8f0",
        popover: "#242424",
        "popover-foreground": "#a9a9a9",
        primary: "#006239",
        "primary-foreground": "#dde8e3",
        secondary: "#242424",
        "secondary-foreground": "#fafafa",
        muted: "#1f1f1f",
        "muted-foreground": "#a2a2a2",
        accent: "#313131",
        "accent-foreground": "#fafafa",
        destructive: "#541c15",
        "destructive-foreground": "#ede9e8",
        border: "#292929",
        input: "#242424",
        ring: "#4ade80",
        "chart-1": "#4ade80",
        "chart-2": "#60a5fa",
        "chart-3": "#a78bfa",
        "chart-4": "#fbbf24",
        "chart-5": "#2dd4bf",
        sidebar: "#121212",
        "sidebar-foreground": "#898989",
        "sidebar-primary": "#006239",
        "sidebar-primary-foreground": "#dde8e3",
        "sidebar-accent": "#313131",
        "sidebar-accent-foreground": "#fafafa",
        "sidebar-border": "#292929",
        "sidebar-ring": "#4ade80",
      },
    },
  },

  "neo-brutalism": {
    label: "Neo Brutalism",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#000000",
        card: "#ffffff",
        "card-foreground": "#000000",
        popover: "#ffffff",
        "popover-foreground": "#000000",
        primary: "#ff3333",
        "primary-foreground": "#ffffff",
        secondary: "#ffff00",
        "secondary-foreground": "#000000",
        muted: "#f0f0f0",
        "muted-foreground": "#333333",
        accent: "#0066ff",
        "accent-foreground": "#ffffff",
        destructive: "#000000",
        "destructive-foreground": "#ffffff",
        border: "#000000",
        input: "#000000",
        ring: "#ff3333",
        "chart-1": "#ff3333",
        "chart-2": "#ffff00",
        "chart-3": "#0066ff",
        "chart-4": "#00cc00",
        "chart-5": "#cc00cc",
        radius: "0px",
        sidebar: "#f0f0f0",
        "sidebar-foreground": "#000000",
        "sidebar-primary": "#ff3333",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#0066ff",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#000000",
        "sidebar-ring": "#ff3333",
        "font-sans": "DM Sans, sans-serif",
        "font-mono": "Space Mono, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "1",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "4px",
        "shadow-offset-y": "4px",
      },
      dark: {
        background: "#000000",
        foreground: "#ffffff",
        card: "#333333",
        "card-foreground": "#ffffff",
        popover: "#333333",
        "popover-foreground": "#ffffff",
        primary: "#ff6666",
        "primary-foreground": "#000000",
        secondary: "#ffff33",
        "secondary-foreground": "#000000",
        muted: "#333333",
        "muted-foreground": "#cccccc",
        accent: "#3399ff",
        "accent-foreground": "#000000",
        destructive: "#ffffff",
        "destructive-foreground": "#000000",
        border: "#ffffff",
        input: "#ffffff",
        ring: "#ff6666",
        "chart-1": "#ff6666",
        "chart-2": "#ffff33",
        "chart-3": "#3399ff",
        "chart-4": "#33cc33",
        "chart-5": "#cc33cc",
        radius: "0px",
        sidebar: "#000000",
        "sidebar-foreground": "#ffffff",
        "sidebar-primary": "#ff6666",
        "sidebar-primary-foreground": "#000000",
        "sidebar-accent": "#3399ff",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#ffffff",
        "sidebar-ring": "#ff6666",
      },
    },
  },

  "solar-dusk": {
    label: "Solar Dusk",
    createdAt: "2025-04-12",
    styles: {
      light: {
        background: "#FDFBF7",
        foreground: "#4A3B33",
        card: "#F8F4EE",
        "card-foreground": "#4A3B33",
        popover: "#F8F4EE",
        "popover-foreground": "#4A3B33",
        primary: "#B45309",
        "primary-foreground": "#FFFFFF",
        secondary: "#E4C090",
        "secondary-foreground": "#57534E",
        muted: "#F1E9DA",
        "muted-foreground": "#78716C",
        accent: "#f2daba",
        "accent-foreground": "#57534E",
        destructive: "#991B1B",
        "destructive-foreground": "#FFFFFF",
        border: "#E4D9BC",
        input: "#E4D9BC",
        ring: "#B45309",
        "chart-1": "#B45309",
        "chart-2": "#78716C",
        "chart-3": "#A16207",
        "chart-4": "#78716C",
        "chart-5": "#CA8A04",
        radius: "0.3rem",
        sidebar: "#F1E9DA",
        "sidebar-foreground": "#4A3B33",
        "sidebar-primary": "#B45309",
        "sidebar-primary-foreground": "#FFFFFF",
        "sidebar-accent": "#A16207",
        "sidebar-accent-foreground": "#FFFFFF",
        "sidebar-border": "#E4D9BC",
        "sidebar-ring": "#B45309",
        "font-sans": "Oxanium, sans-serif",
        "font-serif": "Merriweather, serif",
        "font-mono": "Fira Code, monospace",
        "shadow-color": "hsl(28 18% 25%)",
        "shadow-opacity": "0.18",
        "shadow-blur": "3px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#1C1917",
        foreground: "#F5F5F4",
        card: "#292524",
        "card-foreground": "#F5F5F4",
        popover: "#292524",
        "popover-foreground": "#F5F5F4",
        primary: "#F97316",
        "primary-foreground": "#FFFFFF",
        secondary: "#57534E",
        "secondary-foreground": "#E7E5E4",
        muted: "#292524",
        "muted-foreground": "#A8A29E",
        accent: "#1e4252",
        "accent-foreground": "#E7E5E4",
        destructive: "#DC2626",
        "destructive-foreground": "#FFFFFF",
        border: "#44403C",
        input: "#44403C",
        ring: "#F97316",
        "chart-1": "#F97316",
        "chart-2": "#0EA5E9",
        "chart-3": "#EAB308",
        "chart-4": "#A8A29E",
        "chart-5": "#78716C",
        radius: "0.3rem",
        sidebar: "#292524",
        "sidebar-foreground": "#F5F5F4",
        "sidebar-primary": "#F97316",
        "sidebar-primary-foreground": "#FFFFFF",
        "sidebar-accent": "#0EA5E9",
        "sidebar-accent-foreground": "#0C2A4D",
        "sidebar-border": "#44403C",
        "sidebar-ring": "#F97316",
        "shadow-color": "hsl(0 0% 5%)",
      },
    },
  },

  claymorphism: {
    label: "Claymorphism",
    styles: {
      light: {
        background: "#e7e5e4",
        foreground: "#1e293b",
        card: "#f5f5f4",
        "card-foreground": "#1e293b",
        popover: "#f5f5f4",
        "popover-foreground": "#1e293b",
        primary: "#6366f1",
        "primary-foreground": "#ffffff",
        secondary: "#d6d3d1",
        "secondary-foreground": "#4b5563",
        muted: "#e7e5e4",
        "muted-foreground": "#6b7280",
        accent: "#f3e5f5",
        "accent-foreground": "#374151",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#d6d3d1",
        input: "#d6d3d1",
        ring: "#6366f1",
        "chart-1": "#6366f1",
        "chart-2": "#4f46e5",
        "chart-3": "#4338ca",
        "chart-4": "#3730a3",
        "chart-5": "#312e81",
        radius: "1.25rem",
        sidebar: "#d6d3d1",
        "sidebar-foreground": "#1e293b",
        "sidebar-primary": "#6366f1",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#f3e5f5",
        "sidebar-accent-foreground": "#374151",
        "sidebar-border": "#d6d3d1",
        "sidebar-ring": "#6366f1",
        "font-sans": "Plus Jakarta Sans, sans-serif",
        "font-serif": "Lora, serif",
        "font-mono": "Roboto Mono, monospace",
        "shadow-color": "hsl(240 4% 60%)",
        "shadow-opacity": "0.18",
        "shadow-blur": "10px",
        "shadow-spread": "4px",
        "shadow-offset-x": "2px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#1e1b18",
        foreground: "#e2e8f0",
        card: "#2c2825",
        "card-foreground": "#e2e8f0",
        popover: "#2c2825",
        "popover-foreground": "#e2e8f0",
        primary: "#818cf8",
        "primary-foreground": "#1e1b18",
        secondary: "#3a3633",
        "secondary-foreground": "#d1d5db",
        muted: "#2c2825",
        "muted-foreground": "#9ca3af",
        accent: "#484441",
        "accent-foreground": "#d1d5db",
        destructive: "#ef4444",
        "destructive-foreground": "#1e1b18",
        border: "#3a3633",
        input: "#3a3633",
        ring: "#818cf8",
        "chart-1": "#818cf8",
        "chart-2": "#6366f1",
        "chart-3": "#4f46e5",
        "chart-4": "#4338ca",
        "chart-5": "#3730a3",
        radius: "1.25rem",
        sidebar: "#3a3633",
        "sidebar-foreground": "#e2e8f0",
        "sidebar-primary": "#818cf8",
        "sidebar-primary-foreground": "#1e1b18",
        "sidebar-accent": "#484441",
        "sidebar-accent-foreground": "#d1d5db",
        "sidebar-border": "#3a3633",
        "sidebar-ring": "#818cf8",
        "shadow-color": "hsl(0 0% 0%)",
      },
    },
  },

  cyberpunk: {
    label: "Cyberpunk",
    styles: {
      light: {
        background: "#f8f9fa",
        foreground: "#0c0c1d",
        card: "#ffffff",
        "card-foreground": "#0c0c1d",
        popover: "#ffffff",
        "popover-foreground": "#0c0c1d",
        primary: "#ff00c8",
        "primary-foreground": "#ffffff",
        secondary: "#f0f0ff",
        "secondary-foreground": "#0c0c1d",
        muted: "#f0f0ff",
        "muted-foreground": "#0c0c1d",
        accent: "#00ffcc",
        "accent-foreground": "#0c0c1d",
        destructive: "#ff3d00",
        "destructive-foreground": "#ffffff",
        border: "#dfe6e9",
        input: "#dfe6e9",
        ring: "#ff00c8",
        "chart-1": "#ff00c8",
        "chart-2": "#9000ff",
        "chart-3": "#00e5ff",
        "chart-4": "#00ffcc",
        "chart-5": "#ffe600",
        radius: "0.5rem",
        sidebar: "#f0f0ff",
        "sidebar-foreground": "#0c0c1d",
        "sidebar-primary": "#ff00c8",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#00ffcc",
        "sidebar-accent-foreground": "#0c0c1d",
        "sidebar-border": "#dfe6e9",
        "sidebar-ring": "#ff00c8",
        "font-sans": "Outfit, sans-serif",
        "font-mono": "Fira Code, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.1",
        "shadow-blur": "8px",
        "shadow-spread": "-2px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "4px",
      },
      dark: {
        background: "#0c0c1d",
        foreground: "#eceff4",
        card: "#1e1e3f",
        "card-foreground": "#eceff4",
        popover: "#1e1e3f",
        "popover-foreground": "#eceff4",
        primary: "#ff00c8",
        "primary-foreground": "#ffffff",
        secondary: "#1e1e3f",
        "secondary-foreground": "#eceff4",
        muted: "#1e1e3f",
        "muted-foreground": "#8085a6",
        accent: "#00ffcc",
        "accent-foreground": "#0c0c1d",
        destructive: "#ff3d00",
        "destructive-foreground": "#ffffff",
        border: "#2e2e5e",
        input: "#2e2e5e",
        ring: "#ff00c8",
        "chart-1": "#ff00c8",
        "chart-2": "#9000ff",
        "chart-3": "#00e5ff",
        "chart-4": "#00ffcc",
        "chart-5": "#ffe600",
        radius: "0.5rem",
        sidebar: "#0c0c1d",
        "sidebar-foreground": "#eceff4",
        "sidebar-primary": "#ff00c8",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#00ffcc",
        "sidebar-accent-foreground": "#0c0c1d",
        "sidebar-border": "#2e2e5e",
        "sidebar-ring": "#ff00c8",
      },
    },
  },
  "pastel-dreams": {
    label: "Pastel Dreams",
    styles: {
      light: {
        background: "#f7f3f9",
        foreground: "#374151",
        card: "#ffffff",
        "card-foreground": "#374151",
        popover: "#ffffff",
        "popover-foreground": "#374151",
        primary: "#a78bfa",
        "primary-foreground": "#ffffff",
        secondary: "#e9d8fd",
        "secondary-foreground": "#4b5563",
        muted: "#f3e8ff",
        "muted-foreground": "#6b7280",
        accent: "#f3e5f5",
        "accent-foreground": "#374151",
        destructive: "#fca5a5",
        "destructive-foreground": "#ffffff",
        border: "#e9d8fd",
        input: "#e9d8fd",
        ring: "#a78bfa",
        "chart-1": "#a78bfa",
        "chart-2": "#8b5cf6",
        "chart-3": "#7c3aed",
        "chart-4": "#6d28d9",
        "chart-5": "#5b21b6",
        radius: "1.5rem",
        sidebar: "#e9d8fd",
        "sidebar-foreground": "#374151",
        "sidebar-primary": "#a78bfa",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#f3e5f5",
        "sidebar-accent-foreground": "#374151",
        "sidebar-border": "#e9d8fd",
        "sidebar-ring": "#a78bfa",
        "font-sans": "Open Sans, sans-serif",
        "font-serif": "Source Serif 4, serif",
        "font-mono": "IBM Plex Mono, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.08",
        "shadow-blur": "16px",
        "shadow-spread": "-4px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "8px",
      },
      dark: {
        background: "#1c1917",
        foreground: "#e0e7ff",
        card: "#2d2535",
        "card-foreground": "#e0e7ff",
        popover: "#2d2535",
        "popover-foreground": "#e0e7ff",
        primary: "#c0aafd",
        "primary-foreground": "#1c1917",
        secondary: "#3f324a",
        "secondary-foreground": "#d1d5db",
        muted: "#2d2535",
        "muted-foreground": "#9ca3af",
        accent: "#4a3d5a",
        "accent-foreground": "#d1d5db",
        destructive: "#fca5a5",
        "destructive-foreground": "#1c1917",
        border: "#3f324a",
        input: "#3f324a",
        ring: "#c0aafd",
        "chart-1": "#c0aafd",
        "chart-2": "#a78bfa",
        "chart-3": "#8b5cf6",
        "chart-4": "#7c3aed",
        "chart-5": "#6d28d9",
        radius: "1.5rem",
        sidebar: "#3f324a",
        "sidebar-foreground": "#e0e7ff",
        "sidebar-primary": "#c0aafd",
        "sidebar-primary-foreground": "#1c1917",
        "sidebar-accent": "#4a3d5a",
        "sidebar-accent-foreground": "#d1d5db",
        "sidebar-border": "#3f324a",
        "sidebar-ring": "#c0aafd",
      },
    },
  },

  "clean-slate": {
    label: "Clean Slate",
    styles: {
      light: {
        background: "#f8fafc",
        foreground: "#1e293b",
        card: "#ffffff",
        "card-foreground": "#1e293b",
        popover: "#ffffff",
        "popover-foreground": "#1e293b",
        primary: "#6366f1",
        "primary-foreground": "#ffffff",
        secondary: "#e5e7eb",
        "secondary-foreground": "#374151",
        muted: "#f3f4f6",
        "muted-foreground": "#6b7280",
        accent: "#e0e7ff",
        "accent-foreground": "#374151",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#d1d5db",
        input: "#d1d5db",
        ring: "#6366f1",
        "chart-1": "#6366f1",
        "chart-2": "#4f46e5",
        "chart-3": "#4338ca",
        "chart-4": "#3730a3",
        "chart-5": "#312e81",
        radius: "0.5rem",
        sidebar: "#f3f4f6",
        "sidebar-foreground": "#1e293b",
        "sidebar-primary": "#6366f1",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#e0e7ff",
        "sidebar-accent-foreground": "#374151",
        "sidebar-border": "#d1d5db",
        "sidebar-ring": "#6366f1",
        "font-sans": "Inter, sans-serif",
        "font-serif": "Merriweather, serif",
        "font-mono": "JetBrains Mono, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.1",
        "shadow-blur": "8px",
        "shadow-spread": "-1px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "4px",
      },
      dark: {
        background: "#0f172a",
        foreground: "#e2e8f0",
        card: "#1e293b",
        "card-foreground": "#e2e8f0",
        popover: "#1e293b",
        "popover-foreground": "#e2e8f0",
        primary: "#818cf8",
        "primary-foreground": "#0f172a",
        secondary: "#2d3748",
        "secondary-foreground": "#d1d5db",
        muted: "#1e293b",
        "muted-foreground": "#9ca3af",
        accent: "#374151",
        "accent-foreground": "#d1d5db",
        destructive: "#ef4444",
        "destructive-foreground": "#0f172a",
        border: "#4b5563",
        input: "#4b5563",
        ring: "#818cf8",
        "chart-1": "#818cf8",
        "chart-2": "#6366f1",
        "chart-3": "#4f46e5",
        "chart-4": "#4338ca",
        "chart-5": "#3730a3",
        radius: "0.5rem",
        sidebar: "#1e293b",
        "sidebar-foreground": "#e2e8f0",
        "sidebar-primary": "#818cf8",
        "sidebar-primary-foreground": "#0f172a",
        "sidebar-accent": "#374151",
        "sidebar-accent-foreground": "#d1d5db",
        "sidebar-border": "#4b5563",
        "sidebar-ring": "#818cf8",
      },
    },
  },

  caffeine: {
    label: "Caffeine",
    styles: {
      light: {
        background: "#f9f9f9",
        foreground: "#202020",
        card: "#fcfcfc",
        "card-foreground": "#202020",
        popover: "#fcfcfc",
        "popover-foreground": "#202020",
        primary: "#644a40",
        "primary-foreground": "#ffffff",
        secondary: "#ffdfb5",
        "secondary-foreground": "#582d1d",
        muted: "#efefef",
        "muted-foreground": "#646464",
        accent: "#e8e8e8",
        "accent-foreground": "#202020",
        destructive: "#e54d2e",
        "destructive-foreground": "#ffffff",
        border: "#d8d8d8",
        input: "#d8d8d8",
        ring: "#644a40",
        "chart-1": "#644a40",
        "chart-2": "#ffdfb5",
        "chart-3": "#e8e8e8",
        "chart-4": "#ffe6c4",
        "chart-5": "#66493e",
        sidebar: "#fbfbfb",
        "sidebar-foreground": "#252525",
        "sidebar-primary": "#343434",
        "sidebar-primary-foreground": "#fbfbfb",
        "sidebar-accent": "#f7f7f7",
        "sidebar-accent-foreground": "#343434",
        "sidebar-border": "#ebebeb",
        "sidebar-ring": "#b5b5b5",
        radius: "0.5rem",
      },
      dark: {
        background: "#111111",
        foreground: "#eeeeee",
        card: "#191919",
        "card-foreground": "#eeeeee",
        popover: "#191919",
        "popover-foreground": "#eeeeee",
        primary: "#ffe0c2",
        "primary-foreground": "#081a1b",
        secondary: "#393028",
        "secondary-foreground": "#ffe0c2",
        muted: "#222222",
        "muted-foreground": "#b4b4b4",
        accent: "#2a2a2a",
        "accent-foreground": "#eeeeee",
        destructive: "#e54d2e",
        "destructive-foreground": "#ffffff",
        border: "#201e18",
        input: "#484848",
        ring: "#ffe0c2",
        "chart-1": "#ffe0c2",
        "chart-2": "#393028",
        "chart-3": "#2a2a2a",
        "chart-4": "#42382e",
        "chart-5": "#ffe0c1",
        sidebar: "#18181b",
        "sidebar-foreground": "#f4f4f5",
        "sidebar-primary": "#1d4ed8",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#27272a",
        "sidebar-accent-foreground": "#f4f4f5",
        "sidebar-border": "#27272a",
        "sidebar-ring": "#d4d4d8",
        radius: "0.5rem",
      },
    },
  },
  "ocean-breeze": {
    label: "Ocean Breeze",
    styles: {
      light: {
        background: "#f0f8ff",
        foreground: "#374151",
        card: "#ffffff",
        "card-foreground": "#374151",
        popover: "#ffffff",
        "popover-foreground": "#374151",
        primary: "#22c55e",
        "primary-foreground": "#ffffff",
        secondary: "#e0f2fe",
        "secondary-foreground": "#4b5563",
        muted: "#f3f4f6",
        "muted-foreground": "#6b7280",
        accent: "#d1fae5",
        "accent-foreground": "#374151",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#e5e7eb",
        input: "#e5e7eb",
        ring: "#22c55e",
        "chart-1": "#22c55e",
        "chart-2": "#10b981",
        "chart-3": "#059669",
        "chart-4": "#047857",
        "chart-5": "#065f46",
        radius: "0.5rem",
        sidebar: "#e0f2fe",
        "sidebar-foreground": "#374151",
        "sidebar-primary": "#22c55e",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#d1fae5",
        "sidebar-accent-foreground": "#374151",
        "sidebar-border": "#e5e7eb",
        "sidebar-ring": "#22c55e",
        "font-sans": "DM Sans, sans-serif",
        "font-serif": "Lora, serif",
        "font-mono": "IBM Plex Mono, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.1",
        "shadow-blur": "8px",
        "shadow-spread": "-1px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "4px",
      },
      dark: {
        background: "#0f172a",
        foreground: "#d1d5db",
        card: "#1e293b",
        "card-foreground": "#d1d5db",
        popover: "#1e293b",
        "popover-foreground": "#d1d5db",
        primary: "#34d399",
        "primary-foreground": "#0f172a",
        secondary: "#2d3748",
        "secondary-foreground": "#a1a1aa",
        muted: "#1e293b",
        "muted-foreground": "#6b7280",
        accent: "#374151",
        "accent-foreground": "#a1a1aa",
        destructive: "#ef4444",
        "destructive-foreground": "#0f172a",
        border: "#4b5563",
        input: "#4b5563",
        ring: "#34d399",
        "chart-1": "#34d399",
        "chart-2": "#2dd4bf",
        "chart-3": "#22c55e",
        "chart-4": "#10b981",
        "chart-5": "#059669",
        radius: "0.5rem",
        sidebar: "#1e293b",
        "sidebar-foreground": "#d1d5db",
        "sidebar-primary": "#34d399",
        "sidebar-primary-foreground": "#0f172a",
        "sidebar-accent": "#374151",
        "sidebar-accent-foreground": "#a1a1aa",
        "sidebar-border": "#4b5563",
        "sidebar-ring": "#34d399",
      },
    },
  },
  "retro-arcade": {
    label: "Retro Arcade",
    styles: {
      light: {
        background: "#fdf6e3",
        foreground: "#073642",
        card: "#eee8d5",
        "card-foreground": "#073642",
        popover: "#eee8d5",
        "popover-foreground": "#073642",
        primary: "#d33682",
        "primary-foreground": "#ffffff",
        secondary: "#2aa198",
        "secondary-foreground": "#ffffff",
        muted: "#93a1a1",
        "muted-foreground": "#073642",
        accent: "#cb4b16",
        "accent-foreground": "#ffffff",
        destructive: "#dc322f",
        "destructive-foreground": "#ffffff",
        border: "#839496",
        input: "#839496",
        ring: "#d33682",
        "chart-1": "#268bd2",
        "chart-2": "#2aa198",
        "chart-3": "#d33682",
        "chart-4": "#cb4b16",
        "chart-5": "#dc322f",
        radius: "0.25rem",
        sidebar: "#fdf6e3",
        "sidebar-foreground": "#073642",
        "sidebar-primary": "#d33682",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#2aa198",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#839496",
        "sidebar-ring": "#d33682",
        "font-sans": "Outfit, sans-serif",
        "font-mono": "Space Mono, monospace",
        "shadow-color": "hsl(196 83% 10%)",
        "shadow-opacity": "0.15",
        "shadow-blur": "4px",
        "shadow-spread": "0px",
        "shadow-offset-x": "2px",
        "shadow-offset-y": "2px",
      },
      dark: {
        background: "#002b36",
        foreground: "#93a1a1",
        card: "#073642",
        "card-foreground": "#93a1a1",
        popover: "#073642",
        "popover-foreground": "#93a1a1",
        primary: "#d33682",
        "primary-foreground": "#ffffff",
        secondary: "#2aa198",
        "secondary-foreground": "#ffffff",
        muted: "#586e75",
        "muted-foreground": "#93a1a1",
        accent: "#cb4b16",
        "accent-foreground": "#ffffff",
        destructive: "#dc322f",
        "destructive-foreground": "#ffffff",
        border: "#586e75",
        input: "#586e75",
        ring: "#d33682",
        "chart-1": "#268bd2",
        "chart-2": "#2aa198",
        "chart-3": "#d33682",
        "chart-4": "#cb4b16",
        "chart-5": "#dc322f",
        radius: "0.25rem",
        sidebar: "#002b36",
        "sidebar-foreground": "#93a1a1",
        "sidebar-primary": "#d33682",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#2aa198",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#586e75",
        "sidebar-ring": "#d33682",
      },
    },
  },

  "midnight-bloom": {
    label: "Midnight Bloom",
    styles: {
      light: {
        background: "#f9f9f9",
        foreground: "#333333",
        card: "#ffffff",
        "card-foreground": "#333333",
        popover: "#ffffff",
        "popover-foreground": "#333333",
        primary: "#6c5ce7",
        "primary-foreground": "#ffffff",
        secondary: "#a1c9f2",
        "secondary-foreground": "#333333",
        muted: "#c9c4b5",
        "muted-foreground": "#6e6e6e",
        accent: "#8b9467",
        "accent-foreground": "#ffffff",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#d4d4d4",
        input: "#d4d4d4",
        ring: "#6c5ce7",
        "chart-1": "#6c5ce7",
        "chart-2": "#8e44ad",
        "chart-3": "#4b0082",
        "chart-4": "#6495ed",
        "chart-5": "#4682b4",
        radius: "0.5rem",
        sidebar: "#f9f9f9",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#6c5ce7",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#8b9467",
        "sidebar-accent-foreground": "#ffffff",
        "sidebar-border": "#d4d4d4",
        "sidebar-ring": "#6c5ce7",
        "font-sans": "Montserrat, sans-serif",
        "font-serif": "Playfair Display, serif",
        "font-mono": "Source Code Pro, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.1",
        "shadow-blur": "10px",
        "shadow-spread": "-2px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "5px",
      },
      dark: {
        background: "#1a1d23",
        foreground: "#e5e5e5",
        card: "#2f3436",
        "card-foreground": "#e5e5e5",
        popover: "#2f3436",
        "popover-foreground": "#e5e5e5",
        primary: "#6c5ce7",
        "primary-foreground": "#ffffff",
        secondary: "#4b0082",
        "secondary-foreground": "#e5e5e5",
        muted: "#444444",
        "muted-foreground": "#a3a3a3",
        accent: "#6495ed",
        "accent-foreground": "#e5e5e5",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#444444",
        input: "#444444",
        ring: "#6c5ce7",
        "chart-1": "#6c5ce7",
        "chart-2": "#8e44ad",
        "chart-3": "#4b0082",
        "chart-4": "#6495ed",
        "chart-5": "#4682b4",
        radius: "0.5rem",
        sidebar: "#1a1d23",
        "sidebar-foreground": "#e5e5e5",
        "sidebar-primary": "#6c5ce7",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#6495ed",
        "sidebar-accent-foreground": "#e5e5e5",
        "sidebar-border": "#444444",
        "sidebar-ring": "#6c5ce7",
      },
    },
  },
  candyland: {
    label: "Candyland",
    styles: {
      light: {
        background: "#f7f9fa",
        foreground: "#333333",
        card: "#ffffff",
        "card-foreground": "#333333",
        popover: "#ffffff",
        "popover-foreground": "#333333",
        primary: "#ffc0cb",
        "primary-foreground": "#000000",
        secondary: "#87ceeb",
        "secondary-foreground": "#000000",
        muted: "#ddd9c4",
        "muted-foreground": "#6e6e6e",
        accent: "#ffff00",
        "accent-foreground": "#000000",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#d4d4d4",
        input: "#d4d4d4",
        ring: "#ffc0cb",
        "chart-1": "#ffc0cb",
        "chart-2": "#87ceeb",
        "chart-3": "#ffff00",
        "chart-4": "#ff99cc",
        "chart-5": "#33cc33",
        radius: "0.5rem",
        sidebar: "#f7f9fa",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#ffc0cb",
        "sidebar-primary-foreground": "#000000",
        "sidebar-accent": "#ffff00",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#d4d4d4",
        "sidebar-ring": "#ffc0cb",
        "font-sans": "Poppins, sans-serif",
        "font-mono": "Roboto Mono, monospace",
      },
      dark: {
        background: "#1a1d23",
        foreground: "#e5e5e5",
        card: "#2f3436",
        "card-foreground": "#e5e5e5",
        popover: "#2f3436",
        "popover-foreground": "#e5e5e5",
        primary: "#ff99cc",
        "primary-foreground": "#000000",
        secondary: "#33cc33",
        "secondary-foreground": "#000000",
        muted: "#444444",
        "muted-foreground": "#a3a3a3",
        accent: "#87ceeb",
        "accent-foreground": "#000000",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#444444",
        input: "#444444",
        ring: "#ff99cc",
        "chart-1": "#ff99cc",
        "chart-2": "#33cc33",
        "chart-3": "#87ceeb",
        "chart-4": "#ffff00",
        "chart-5": "#ffcc00",
        radius: "0.5rem",
        sidebar: "#1a1d23",
        "sidebar-foreground": "#e5e5e5",
        "sidebar-primary": "#ff99cc",
        "sidebar-primary-foreground": "#000000",
        "sidebar-accent": "#87ceeb",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#444444",
        "sidebar-ring": "#ff99cc",
      },
    },
  },
  "northern-lights": {
    label: "Northern Lights",
    styles: {
      light: {
        background: "#f9f9fa",
        foreground: "#333333",
        card: "#ffffff",
        "card-foreground": "#333333",
        popover: "#ffffff",
        "popover-foreground": "#333333",
        primary: "#34a85a",
        "primary-foreground": "#ffffff",
        secondary: "#6495ed",
        "secondary-foreground": "#ffffff",
        muted: "#ddd9c4",
        "muted-foreground": "#6e6e6e",
        accent: "#66d9ef",
        "accent-foreground": "#333333",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#d4d4d4",
        input: "#d4d4d4",
        ring: "#34a85a",
        "chart-1": "#34a85a",
        "chart-2": "#6495ed",
        "chart-3": "#66d9ef",
        "chart-4": "#4682b4",
        "chart-5": "#1a9641",
        radius: "0.5rem",
        sidebar: "#f9f9fa",
        "sidebar-foreground": "#333333",
        "sidebar-primary": "#34a85a",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#66d9ef",
        "sidebar-accent-foreground": "#333333",
        "sidebar-border": "#d4d4d4",
        "sidebar-ring": "#34a85a",
        "font-sans": "Plus Jakarta Sans, sans-serif",
        "font-serif": "Source Serif 4, serif",
        "font-mono": "JetBrains Mono, monospace",
      },
      dark: {
        background: "#1a1d23",
        foreground: "#e5e5e5",
        card: "#2f3436",
        "card-foreground": "#e5e5e5",
        popover: "#2f3436",
        "popover-foreground": "#e5e5e5",
        primary: "#34a85a",
        "primary-foreground": "#ffffff",
        secondary: "#4682b4",
        "secondary-foreground": "#e5e5e5",
        muted: "#444444",
        "muted-foreground": "#a3a3a3",
        accent: "#6495ed",
        "accent-foreground": "#e5e5e5",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#444444",
        input: "#444444",
        ring: "#34a85a",
        "chart-1": "#34a85a",
        "chart-2": "#4682b4",
        "chart-3": "#6495ed",
        "chart-4": "#66d9ef",
        "chart-5": "#1a9641",
        radius: "0.5rem",
        sidebar: "#1a1d23",
        "sidebar-foreground": "#e5e5e5",
        "sidebar-primary": "#34a85a",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#6495ed",
        "sidebar-accent-foreground": "#e5e5e5",
        "sidebar-border": "#444444",
        "sidebar-ring": "#34a85a",
      },
    },
  },
  "vintage-paper": {
    label: "Vintage Paper",
    styles: {
      light: {
        background: "#f5f1e6",
        foreground: "#4a3f35",
        card: "#fffcf5",
        "card-foreground": "#4a3f35",
        popover: "#fffcf5",
        "popover-foreground": "#4a3f35",
        primary: "#a67c52",
        "primary-foreground": "#ffffff",
        secondary: "#e2d8c3",
        "secondary-foreground": "#5c4d3f",
        muted: "#ece5d8",
        "muted-foreground": "#7d6b56",
        accent: "#d4c8aa",
        "accent-foreground": "#4a3f35",
        destructive: "#b54a35",
        "destructive-foreground": "#ffffff",
        border: "#dbd0ba",
        input: "#dbd0ba",
        ring: "#a67c52",
        "chart-1": "#a67c52",
        "chart-2": "#8d6e4c",
        "chart-3": "#735a3a",
        "chart-4": "#b3906f",
        "chart-5": "#c0a080",
        radius: "0.25rem",
        sidebar: "#ece5d8",
        "sidebar-foreground": "#4a3f35",
        "sidebar-primary": "#a67c52",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#d4c8aa",
        "sidebar-accent-foreground": "#4a3f35",
        "sidebar-border": "#dbd0ba",
        "sidebar-ring": "#a67c52",
        "font-sans": "Libre Baskerville, serif",
        "font-serif": "Lora, serif",
        "font-mono": "IBM Plex Mono, monospace",
        "shadow-color": "hsl(28 13% 20%)",
        "shadow-opacity": "0.12",
        "shadow-blur": "5px",
        "shadow-spread": "0px",
        "shadow-offset-x": "2px",
        "shadow-offset-y": "3px",
      },
      dark: {
        background: "#2d2621",
        foreground: "#ece5d8",
        card: "#3a322c",
        "card-foreground": "#ece5d8",
        popover: "#3a322c",
        "popover-foreground": "#ece5d8",
        primary: "#c0a080",
        "primary-foreground": "#2d2621",
        secondary: "#4a4039",
        "secondary-foreground": "#ece5d8",
        muted: "#3a322c",
        "muted-foreground": "#c5bcac",
        accent: "#59493e",
        "accent-foreground": "#ece5d8",
        destructive: "#b54a35",
        "destructive-foreground": "#ffffff",
        border: "#4a4039",
        input: "#4a4039",
        ring: "#c0a080",
        "chart-1": "#c0a080",
        "chart-2": "#b3906f",
        "chart-3": "#a67c52",
        "chart-4": "#8d6e4c",
        "chart-5": "#735a3a",
        radius: "0.25rem",
        sidebar: "#2d2621",
        "sidebar-foreground": "#ece5d8",
        "sidebar-primary": "#c0a080",
        "sidebar-primary-foreground": "#2d2621",
        "sidebar-accent": "#59493e",
        "sidebar-accent-foreground": "#ece5d8",
        "sidebar-border": "#4a4039",
        "sidebar-ring": "#c0a080",
      },
    },
  },
  "sunset-horizon": {
    label: "Sunset Horizon",
    styles: {
      light: {
        background: "#fff9f5",
        foreground: "#3d3436",
        card: "#ffffff",
        "card-foreground": "#3d3436",
        popover: "#ffffff",
        "popover-foreground": "#3d3436",
        primary: "#ff7e5f",
        "primary-foreground": "#ffffff",
        secondary: "#ffedea",
        "secondary-foreground": "#b35340",
        muted: "#fff0eb",
        "muted-foreground": "#78716C",
        accent: "#feb47b",
        "accent-foreground": "#3d3436",
        destructive: "#e63946",
        "destructive-foreground": "#ffffff",
        border: "#ffe0d6",
        input: "#ffe0d6",
        ring: "#ff7e5f",
        "chart-1": "#ff7e5f",
        "chart-2": "#feb47b",
        "chart-3": "#ffcaa7",
        "chart-4": "#ffad8f",
        "chart-5": "#ce6a57",
        radius: "0.625rem",
        sidebar: "#fff0eb",
        "sidebar-foreground": "#3d3436",
        "sidebar-primary": "#ff7e5f",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#feb47b",
        "sidebar-accent-foreground": "#3d3436",
        "sidebar-border": "#ffe0d6",
        "sidebar-ring": "#ff7e5f",
        "font-sans": "Montserrat, sans-serif",
        "font-serif": "Merriweather, serif",
        "font-mono": "Ubuntu Mono, monospace",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.09",
        "shadow-blur": "12px",
        "shadow-spread": "-3px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "6px",
      },
      dark: {
        background: "#2a2024",
        foreground: "#f2e9e4",
        card: "#392f35",
        "card-foreground": "#f2e9e4",
        popover: "#392f35",
        "popover-foreground": "#f2e9e4",
        primary: "#ff7e5f",
        "primary-foreground": "#ffffff",
        secondary: "#463a41",
        "secondary-foreground": "#f2e9e4",
        muted: "#392f35",
        "muted-foreground": "#d7c6bc",
        accent: "#feb47b",
        "accent-foreground": "#2a2024",
        destructive: "#e63946",
        "destructive-foreground": "#ffffff",
        border: "#463a41",
        input: "#463a41",
        ring: "#ff7e5f",
        "chart-1": "#ff7e5f",
        "chart-2": "#feb47b",
        "chart-3": "#ffcaa7",
        "chart-4": "#ffad8f",
        "chart-5": "#ce6a57",
        radius: "0.625rem",
        sidebar: "#2a2024",
        "sidebar-foreground": "#f2e9e4",
        "sidebar-primary": "#ff7e5f",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#feb47b",
        "sidebar-accent-foreground": "#2a2024",
        "sidebar-border": "#463a41",
        "sidebar-ring": "#ff7e5f",
      },
    },
  },

  "starry-night": {
    label: "Starry Night",
    createdAt: "2025-04-16",
    styles: {
      light: {
        background: "#f5f7fa",
        foreground: "#1a2238",
        card: "#e3eaf2",
        "card-foreground": "#1a2238",
        popover: "#fffbe6",
        "popover-foreground": "#1a2238",
        primary: "#3a5ba0",
        "primary-foreground": "#fffbe6",
        secondary: "#f7c873",
        "secondary-foreground": "#1a2238",
        muted: "#e5e5df",
        "muted-foreground": "#3a5ba0",
        accent: "#6ea3c1",
        "accent-foreground": "#fffbe6",
        destructive: "#2d1e2f",
        "destructive-foreground": "#fffbe6",
        border: "#b0b8c1",
        input: "#6ea3c1",
        ring: "#f7c873",
        "chart-1": "#3a5ba0",
        "chart-2": "#f7c873",
        "chart-3": "#6ea3c1",
        "chart-4": "#b0b8c1",
        "chart-5": "#2d1e2f",
        sidebar: "#e3eaf2",
        "sidebar-foreground": "#1a2238",
        "sidebar-primary": "#3a5ba0",
        "sidebar-primary-foreground": "#fffbe6",
        "sidebar-accent": "#f7c873",
        "sidebar-accent-foreground": "#1a2238",
        "sidebar-border": "#b0b8c1",
        "sidebar-ring": "#f7c873",
        "font-sans": "Libre Baskerville, serif",
        radius: "0.5rem",
      },
      dark: {
        background: "#181a24",
        foreground: "#e6eaf3",
        card: "#23243a",
        "card-foreground": "#e6eaf3",
        popover: "#23243a",
        "popover-foreground": "#ffe066",
        primary: "#3a5ba0",
        "primary-foreground": "#ffe066",
        secondary: "#ffe066",
        "secondary-foreground": "#23243a",
        muted: "#23243a",
        "muted-foreground": "#7a88a1",
        accent: "#bccdf0",
        "accent-foreground": "#181a24",
        destructive: "#a04a6c",
        "destructive-foreground": "#ffe066",
        border: "#2d2e3e",
        input: "#3a5ba0",
        ring: "#ffe066",
        "chart-1": "#3a5ba0",
        "chart-2": "#ffe066",
        "chart-3": "#6ea3c1",
        "chart-4": "#7a88a1",
        "chart-5": "#a04a6c",
        sidebar: "#23243a",
        "sidebar-foreground": "#e6eaf3",
        "sidebar-primary": "#3a5ba0",
        "sidebar-primary-foreground": "#ffe066",
        "sidebar-accent": "#ffe066",
        "sidebar-accent-foreground": "#23243a",
        "sidebar-border": "#2d2e3e",
        "sidebar-ring": "#ffe066",
        radius: "0.5rem",
      },
    },
  },

  claude: {
    label: "Claude",
    styles: {
      light: {
        background: "#faf9f5",
        foreground: "#3d3929",
        card: "#faf9f5",
        "card-foreground": "#141413",
        popover: "#ffffff",
        "popover-foreground": "#28261b",
        primary: "#c96442",
        "primary-foreground": "#ffffff",
        secondary: "#e9e6dc",
        "secondary-foreground": "#535146",
        muted: "#ede9de",
        "muted-foreground": "#83827d",
        accent: "#e9e6dc",
        "accent-foreground": "#28261b",
        destructive: "#141413",
        "destructive-foreground": "#ffffff",
        border: "#dad9d4",
        input: "#b4b2a7",
        ring: "#c96442",
        "chart-1": "#b05730",
        "chart-2": "#9c87f5",
        "chart-3": "#ded8c4",
        "chart-4": "#dbd3f0",
        "chart-5": "#b4552d",
        sidebar: "#f5f4ee",
        "sidebar-foreground": "#3d3d3a",
        "sidebar-primary": "#c96442",
        "sidebar-primary-foreground": "#fbfbfb",
        "sidebar-accent": "#e9e6dc",
        "sidebar-accent-foreground": "#343434",
        "sidebar-border": "#ebebeb",
        "sidebar-ring": "#b5b5b5",
        radius: "0.5rem",
      },
      dark: {
        background: "#262624",
        foreground: "#c3c0b6",
        card: "#262624",
        "card-foreground": "#faf9f5",
        popover: "#30302e",
        "popover-foreground": "#e5e5e2",
        primary: "#d97757",
        "primary-foreground": "#ffffff",
        secondary: "#faf9f5",
        "secondary-foreground": "#30302e",
        muted: "#1b1b19",
        "muted-foreground": "#b7b5a9",
        accent: "#1a1915",
        "accent-foreground": "#f5f4ee",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#3e3e38",
        input: "#52514a",
        ring: "#d97757",
        "chart-1": "#b05730",
        "chart-2": "#9c87f5",
        "chart-3": "#1a1915",
        "chart-4": "#2f2b48",
        "chart-5": "#b4552d",
        sidebar: "#1f1e1d",
        "sidebar-foreground": "#c3c0b6",
        "sidebar-primary": "#343434",
        "sidebar-primary-foreground": "#fbfbfb",
        "sidebar-accent": "#0f0f0e",
        "sidebar-accent-foreground": "#c3c0b6",
        "sidebar-border": "#ebebeb",
        "sidebar-ring": "#b5b5b5",
      },
    },
  },

  vercel: {
    label: "Vercel",
    createdAt: "2025-04-13",
    styles: {
      light: {
        background: "oklch(0.99 0 0)",
        foreground: "oklch(0 0 0)",
        card: "oklch(1.00 0 0)",
        "card-foreground": "oklch(0 0 0)",
        popover: "oklch(0.99 0 0)",
        "popover-foreground": "oklch(0 0 0)",
        primary: "oklch(0 0 0)",
        "primary-foreground": "oklch(1.00 0 0)",
        secondary: "oklch(0.94 0 0)",
        "secondary-foreground": "oklch(0 0 0)",
        muted: "oklch(0.97 0 0)",
        "muted-foreground": "oklch(0.44 0 0)",
        accent: "oklch(0.94 0 0)",
        "accent-foreground": "oklch(0 0 0)",
        destructive: "oklch(0.63 0.19 23.03)",
        "destructive-foreground": "oklch(1.00 0 0)",
        border: "oklch(0.92 0 0)",
        input: "oklch(0.94 0 0)",
        ring: "oklch(0 0 0)",
        "chart-1": "oklch(0.81 0.17 75.35)",
        "chart-2": "oklch(0.55 0.22 264.53)",
        "chart-3": "oklch(0.72 0 0)",
        "chart-4": "oklch(0.92 0 0)",
        "chart-5": "oklch(0.56 0 0)",
        sidebar: "oklch(0.99 0 0)",
        "sidebar-foreground": "oklch(0 0 0)",
        "sidebar-primary": "oklch(0 0 0)",
        "sidebar-primary-foreground": "oklch(1.00 0 0)",
        "sidebar-accent": "oklch(0.94 0 0)",
        "sidebar-accent-foreground": "oklch(0 0 0)",
        "sidebar-border": "oklch(0.94 0 0)",
        "sidebar-ring": "oklch(0 0 0)",
        "font-sans": "Geist, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Geist Mono, monospace",
        radius: "0.5rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0.18",
        "shadow-blur": "2px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "1px",
      },

      dark: {
        background: "oklch(0 0 0)",
        foreground: "oklch(1.00 0 0)",
        card: "oklch(0.14 0 0)",
        "card-foreground": "oklch(1.00 0 0)",
        popover: "oklch(0.18 0 0)",
        "popover-foreground": "oklch(1.00 0 0)",
        primary: "oklch(1.00 0 0)",
        "primary-foreground": "oklch(0 0 0)",
        secondary: "oklch(0.25 0 0)",
        "secondary-foreground": "oklch(1.00 0 0)",
        muted: "oklch(0.23 0 0)",
        "muted-foreground": "oklch(0.72 0 0)",
        accent: "oklch(0.32 0 0)",
        "accent-foreground": "oklch(1.00 0 0)",
        destructive: "oklch(0.69 0.20 23.91)",
        "destructive-foreground": "oklch(0 0 0)",
        border: "oklch(0.26 0 0)",
        input: "oklch(0.32 0 0)",
        ring: "oklch(0.72 0 0)",
        "chart-1": "oklch(0.81 0.17 75.35)",
        "chart-2": "oklch(0.58 0.21 260.84)",
        "chart-3": "oklch(0.56 0 0)",
        "chart-4": "oklch(0.44 0 0)",
        "chart-5": "oklch(0.92 0 0)",
        sidebar: "oklch(0.18 0 0)",
        "sidebar-foreground": "oklch(1.00 0 0)",
        "sidebar-primary": "oklch(1.00 0 0)",
        "sidebar-primary-foreground": "oklch(0 0 0)",
        "sidebar-accent": "oklch(0.32 0 0)",
        "sidebar-accent-foreground": "oklch(1.00 0 0)",
        "sidebar-border": "oklch(0.32 0 0)",
        "sidebar-ring": "oklch(0.72 0 0)",
        "font-sans": "Geist, sans-serif",
        "font-serif": "Georgia, serif",
        "font-mono": "Geist Mono, monospace",
      },
    },
  },

  darkmatter: {
    label: "Darkmatter",
    createdAt: "2025-08-23",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#111827",
        card: "#ffffff",
        "card-foreground": "#111827",
        popover: "#ffffff",
        "popover-foreground": "#111827",
        primary: "#d87943",
        "primary-foreground": "#ffffff",
        secondary: "#527575",
        "secondary-foreground": "#ffffff",
        muted: "#f3f4f6",
        "muted-foreground": "#6b7280",
        accent: "#eeeeee",
        "accent-foreground": "#111827",
        destructive: "#ef4444",
        "destructive-foreground": "#fafafa",
        border: "#e5e7eb",
        input: "#e5e7eb",
        ring: "#d87943",
        "chart-1": "#5f8787",
        "chart-2": "#e78a53",
        "chart-3": "#fbcb97",
        "chart-4": "#888888",
        "chart-5": "#999999",
        sidebar: "#f3f4f6",
        "sidebar-foreground": "#111827",
        "sidebar-primary": "#d87943",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#ffffff",
        "sidebar-accent-foreground": "#111827",
        "sidebar-border": "#e5e7eb",
        "sidebar-ring": "#d87943",
        "font-sans": "Geist Mono, ui-monospace, monospace",
        "font-serif": "serif",
        "font-mono": "JetBrains Mono, monospace",
        radius: "0.75rem",
        "shadow-color": "#000000",
        "shadow-opacity": "0.05",
        "shadow-blur": "4px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "1px",
        "letter-spacing": "0rem",
        spacing: "0.25rem",
      },
      dark: {
        background: "#121113",
        foreground: "#c1c1c1",
        card: "#121212",
        "card-foreground": "#c1c1c1",
        popover: "#121113",
        "popover-foreground": "#c1c1c1",
        primary: "#e78a53",
        "primary-foreground": "#121113",
        secondary: "#5f8787",
        "secondary-foreground": "#121113",
        muted: "#222222",
        "muted-foreground": "#888888",
        accent: "#333333",
        "accent-foreground": "#c1c1c1",
        destructive: "#5f8787",
        "destructive-foreground": "#121113",
        border: "#222222",
        input: "#222222",
        ring: "#e78a53",
        "chart-1": "#5f8787",
        "chart-2": "#e78a53",
        "chart-3": "#fbcb97",
        "chart-4": "#888888",
        "chart-5": "#999999",
        sidebar: "#121212",
        "sidebar-foreground": "#c1c1c1",
        "sidebar-primary": "#e78a53",
        "sidebar-primary-foreground": "#121113",
        "sidebar-accent": "#333333",
        "sidebar-accent-foreground": "#c1c1c1",
        "sidebar-border": "#222222",
        "sidebar-ring": "#e78a53",
        "shadow-color": "#000000",
      },
    },
  },

  mono: {
    label: "Mono",
    createdAt: "2025-04-20",
    styles: {
      light: {
        background: "#ffffff",
        foreground: "#0a0a0a",
        card: "#ffffff",
        "card-foreground": "#0a0a0a",
        popover: "#ffffff",
        "popover-foreground": "#0a0a0a",
        primary: "#737373",
        "primary-foreground": "#fafafa",
        secondary: "#f5f5f5",
        "secondary-foreground": "#171717",
        muted: "#f5f5f5",
        "muted-foreground": "#717171",
        accent: "#f5f5f5",
        "accent-foreground": "#171717",
        destructive: "#e7000b",
        "destructive-foreground": "#f5f5f5",
        border: "#e5e5e5",
        input: "#e5e5e5",
        ring: "#a1a1a1",
        "chart-1": "#737373",
        "chart-2": "#737373",
        "chart-3": "#737373",
        "chart-4": "#737373",
        "chart-5": "#737373",
        sidebar: "#fafafa",
        "sidebar-foreground": "#0a0a0a",
        "sidebar-primary": "#171717",
        "sidebar-primary-foreground": "#fafafa",
        "sidebar-accent": "#f5f5f5",
        "sidebar-accent-foreground": "#171717",
        "sidebar-border": "#e5e5e5",
        "sidebar-ring": "#a1a1a1",
        "font-sans": "Geist Mono, monospace",
        "font-serif": "Geist Mono, monospace",
        "font-mono": "Geist Mono, monospace",
        radius: "0rem",
        "shadow-color": "hsl(0 0% 0%)",
        "shadow-opacity": "0",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "1px",
      },
      dark: {
        background: "#0a0a0a",
        foreground: "#fafafa",
        card: "#191919",
        "card-foreground": "#fafafa",
        popover: "#262626",
        "popover-foreground": "#fafafa",
        primary: "#737373",
        "primary-foreground": "#fafafa",
        secondary: "#262626",
        "secondary-foreground": "#fafafa",
        muted: "#262626",
        "muted-foreground": "#a1a1a1",
        accent: "#404040",
        "accent-foreground": "#fafafa",
        destructive: "#ff6467",
        "destructive-foreground": "#262626",
        border: "#383838",
        input: "#525252",
        ring: "#737373",
        "chart-1": "#737373",
        "chart-2": "#737373",
        "chart-3": "#737373",
        "chart-4": "#737373",
        "chart-5": "#737373",
        sidebar: "#171717",
        "sidebar-foreground": "#fafafa",
        "sidebar-primary": "#fafafa",
        "sidebar-primary-foreground": "#171717",
        "sidebar-accent": "#262626",
        "sidebar-accent-foreground": "#fafafa",
        "sidebar-border": "#ffffff",
        "sidebar-ring": "#525252",
      },
    },
  },
  "soft-pop": {
    label: "Soft Pop",
    createdAt: "2025-07-08",
    styles: {
      light: {
        background: "#f7f9f3",
        foreground: "#000000",
        card: "#ffffff",
        "card-foreground": "#000000",
        popover: "#ffffff",
        "popover-foreground": "#000000",
        primary: "#4f46e5",
        "primary-foreground": "#ffffff",
        secondary: "#14b8a6",
        "secondary-foreground": "#ffffff",
        muted: "#f0f0f0",
        "muted-foreground": "#333333",
        accent: "#f59e0b",
        "accent-foreground": "#000000",
        destructive: "#ef4444",
        "destructive-foreground": "#ffffff",
        border: "#000000",
        input: "#737373",
        ring: "#a5b4fc",
        "chart-1": "#4f46e5",
        "chart-2": "#14b8a6",
        "chart-3": "#f59e0b",
        "chart-4": "#ec4899",
        "chart-5": "#22c55e",
        sidebar: "#f7f9f3",
        "sidebar-foreground": "#000000",
        "sidebar-primary": "#4f46e5",
        "sidebar-primary-foreground": "#ffffff",
        "sidebar-accent": "#f59e0b",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#000000",
        "sidebar-ring": "#a5b4fc",
        "font-sans": "DM Sans, sans-serif",
        "font-serif": "DM Sans, sans-serif",
        "font-mono": "Space Mono, monospace",
        radius: "1rem",
        "shadow-color": "#1a1a1a",
        "shadow-opacity": "0.05",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "0px",
        "letter-spacing": "normal",
        spacing: "0.25rem",
      },
      dark: {
        background: "#000000",
        foreground: "#ffffff",
        card: "#1a212b",
        "card-foreground": "#ffffff",
        popover: "#1a212b",
        "popover-foreground": "#ffffff",
        primary: "#818cf8",
        "primary-foreground": "#000000",
        secondary: "#2dd4bf",
        "secondary-foreground": "#000000",
        muted: "#333333",
        "muted-foreground": "#cccccc",
        accent: "#fcd34d",
        "accent-foreground": "#000000",
        destructive: "#f87171",
        "destructive-foreground": "#000000",
        border: "#545454",
        input: "#ffffff",
        ring: "#818cf8",
        "chart-1": "#818cf8",
        "chart-2": "#2dd4bf",
        "chart-3": "#fcd34d",
        "chart-4": "#f472b6",
        "chart-5": "#4ade80",
        sidebar: "#000000",
        "sidebar-foreground": "#ffffff",
        "sidebar-primary": "#818cf8",
        "sidebar-primary-foreground": "#000000",
        "sidebar-accent": "#fcd34d",
        "sidebar-accent-foreground": "#000000",
        "sidebar-border": "#ffffff",
        "sidebar-ring": "#818cf8",
        "font-sans": "DM Sans, sans-serif",
        "font-serif": "DM Sans, sans-serif",
        "font-mono": "Space Mono, monospace",
        radius: "1rem",
        "shadow-color": "#1a1a1a",
        "shadow-opacity": "0.05",
        "shadow-blur": "0px",
        "shadow-spread": "0px",
        "shadow-offset-x": "0px",
        "shadow-offset-y": "0px",
        "letter-spacing": "normal",
        spacing: "0.25rem",
      },
    },
  },
};
